<template>
  <div class="main_app_contain">
    
    <!--top nav-->
    <!--
    <b-row align-v="center">
      <b-col class="text-center mb-2 mt-2" align-v="center" v-if="active_tab_name !== 'Send Messages'">
        <base-button size="sm" type="success">Quick Send</base-button>
      </b-col>
    </b-row>
    -->


    <div>
      <b-navbar class="bg-white navbar-horizontal pt-1 pb-1">

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>

              <li class="nav-item top_nav_li nav-link" v-on:click="change_tab('this_contact')" id="this_contact_nav_button">
                <span class="material-icons material-icons-outlined md-18">checklist_rtl</span>
                <div  v-if="this.has_contact_data === true">

                  
                  <span class="small_btn_text" v-if="this.this_vue_data_front_context &&
                  typeof this.this_vue_data_front_context.conversation !== 'undefined' &&
                  typeof this.this_vue_data_front_context.conversation.recipient !=='undefined' &&
                  typeof this.this_vue_data_front_context.conversation.recipient.handle !== 'undefined' &&
                  this.this_vue_data_front_context.conversation.recipient.handle !== null ">
                    {{this.this_vue_data_front_context.conversation.recipient.handle}}
                  </span>
                  <span class="small_btn_text small_btn_text_bottom" v-if="this.contact_data && this.contact_data.contact_lists_data">{{this.contact_data.contact_lists_data.first_name || null}} {{this.contact_data.contact_lists_data.last_name || null}} </span>
                </div>
                <div v-else>
                  <span class="small_btn_text">No Contact</span>
                </div>
                  
              </li>

                <li class="nav-item top_nav_li nav-link" v-on:click="change_tab('home')"   id="home_nav_button">
        
                        <span class="material-icons material-icons-sharp md-18">insights</span>
                        <span class="small_btn_text">Insights</span>
                   
                </li>

                <b-nav-item-dropdown right>
                  <template v-slot:button-content id="campaigns_parent_nav_button">
                    <span class="material-icons material-icons-outlined md-18">campaign</span>
                  </template>

                  <b-dropdown-item v-on:click="change_tab('campaigns')" id="campaigns_nav_button" v-if="this.active_user.permissions.includes('campaigns:read')">
                    <span class="material-icons  md-18 material-icons-outlined">campaign</span>
                    <span class="small_btn_text_inline">Campaigns</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-on:click="change_tab('scripts')" id="scripts_nav_button"  v-if="this.active_user.permissions.includes('scripts:read')">
                    <span class="material-icons  md-18 material-icons-outlined">chat</span>
                    <span class="small_btn_text_inline">Scripts</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-on:click="change_tab('survey_questions')" id="survey_questions_nav_button" v-if="this.active_user.permissions.includes('survey_questions:read')">
                    <span class="material-icons  md-18 material-icons-outlined">poll</span>
                    <span class="small_btn_text_inline">Survey Questions</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-on:click="change_tab('quick_replies')" id="quick_replies_nav_button" v-if="this.active_user.permissions.includes('quick_replies:read')">
                    <span class="material-icons  md-18 material-icons-outlined">quickreply</span>
                    <span class="small_btn_text_inline">Quick Replies</span>
                  </b-dropdown-item>



                </b-nav-item-dropdown>
                
                <b-nav-item-dropdown right>

                  <template v-slot:button-content id="people_nav_button">
                    <span class="material-icons material-icons-outlined md-18">people_outline</span>
                  </template>

                  <b-dropdown-item v-on:click="change_tab('users')" v-if="this.active_user.permissions.includes('users:read')">
                    <span class="material-icons  md-18 material-icons-outlined">manage_accounts</span>
                    <span class="small_btn_text_inline">User Accounts</span>
                  </b-dropdown-item>

                  <b-dropdown-divider></b-dropdown-divider>

                  <b-dropdown-item v-on:click="change_tab('lists')"  v-if="this.active_user.permissions.includes('contacts:read')">
                    <span class="material-icons  md-18 material-icons-outlined">folder_shared</span>
                    <span class="small_btn_text_inline">Lists</span>
                  </b-dropdown-item>

                  <!--
                  <b-dropdown-item>
                    <span class="material-icons  md-18 material-icons-outlined">person_search</span>
                    <span class="small_btn_text_inline">View Contacts</span>
                  </b-dropdown-item>

                  -->

                  <b-dropdown-item v-on:click="change_tab('upload_contacts')"  v-if="this.active_user.permissions.includes('contacts:create')">
                    <span class="material-icons material-icons-outlined md-18">file_upload</span>
                    <span class="small_btn_text_inline">Upload</span>
                  </b-dropdown-item>

                </b-nav-item-dropdown>

                <li class="pl-2 pr-2 " v-on:click="change_tab('send_messages')"  v-if="this.active_user.permissions.includes('messages:send')">
                  <a class="message_bubble_blue">
                    <span class="material-icons material-icons-outlined md-18">&#xe625;</span> 
                  </a>
              </li>

            </b-nav-form>

          </b-navbar-nav>
        </b-navbar>
    </div>

    <b-overlay :show="loading_init_data"  opacity="0.9" spinner-variant="primary" spinner-type="grow" spinner-large>
      <b-card :aria-hidden="loading_init_data ? 'true' : null" v-if="loading_init_data === true" align-h="center" align-v="center" class="d-flex justify-content-center mb-3" style="position:fixed;top:0px;width:100%;height:100%;z-index:1000;">
        
        <h1 class="text-center">Loading data...</h1>
        <div style="max-width: 80px;margin:0 auto;">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12" style="max-width:80px">
            <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
            </circle>
            <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
            </circle>
            <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
            </circle>
          </svg>
        </div>
        
       
      </b-card>
      <!--
      <div style="position:fixed;width:100%;height:100%;z-index:10000;background:black;opacity:.75" :aria-hidden="loading_init_data ? 'true' : null" class="total_page_load_overlay_div">

      </div>
      -->
    </b-overlay>

      <b-container fluid class="main_body_content" >

        <div v-if="active_tab_name === 'home' ">
          <stats_page>
          </stats_page>
        
        </div><!--home-->

        <div v-if="active_tab_name === 'users'">
          <manage_users>

          </manage_users>
        </div>

        <div v-if="active_tab_name === 'this_contact'">
         <this_contact>

           </this_contact>
        </div>

        <div v-if="active_tab_name === 'upload_contacts'">
          <upload_contacts>

          </upload_contacts>
        </div>

        <div v-if="active_tab_name === 'scripts' ">
          <scripts>

          </scripts>
        </div><!--scripts-->

        <div v-if="active_tab_name === 'campaigns' ">
          <campaigns>

          </campaigns>
        </div><!--Campaigns-->

        <div v-if="active_tab_name === 'survey_questions' ">
          <survey_questions>

          </survey_questions>
        </div>

         <div v-if="active_tab_name === 'quick_replies' ">
          <quick_replies>
          </quick_replies>
        </div>

        <div v-if="active_tab_name === 'lists' ">
          <lists>

          </lists>
        </div><!--lists-->
  

        <div v-if="active_tab_name === 'send_messages' ">
          <send_messages></send_messages>

        
        </div><!-- send messages-->
        
        
      </b-container>
    

   
  </div>


</template>


<!--
 <script src="https://dl.frontapp.com/libs/plugin-sdk-1.0.1.min.js"></script>
      front_plugin.setAttribute('src', 'https://dl.frontapp.com/libs/plugin-sdk-1.0.1.min.js')
-->

<script>
  import StatsCard from '@/components/Cards/StatsCard';
  import notifications from '@/components/NotificationPlugin/Notifications.vue';
  import form_components from './Forms/FormComponents.vue'
  import form_elements from './Forms/FormElements.vue'

  import helpers from '@/util/helpers.js'

  const handlebars = require("handlebars");

  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  import { Modal, BaseAlert } from '@/components';
  import { SpinnerPlugin, BOverlay } from 'bootstrap-vue'
  import moment from 'moment';
 


  var safe_buffer = require('safe-buffer').Buffer

  //import sidebar from '@/components/SidebarPlugin/SidebarItem.vue'

  //pages TODO turn this into routes and change the nav
  import campaigns from './Tables/campaigns.vue'
  import scripts from './Tables/scripts.vue'

  import survey_questions from './Tables/survey_questions.vue'

  import lists from './Tables/lists.vue'
  import manage_users from './Tables/users.vue'
  import send_messages from './send_messages.vue'
  import upload_contacts from './import_contacts.vue'
  import this_contact from './this_contact.vue'
  import quick_replies from './Tables/quick_replies.vue'

  import stats_page from './stats.vue'


  ///import data_sync_mixin from '@/util/data_sync'


  export default {
    name: 'starter-page',
    components: {
      SpinnerPlugin,
      BOverlay,
      StatsCard,
      notifications,
      campaigns: campaigns,
      scripts: scripts,
      survey_questions: survey_questions,
      lists: lists,
      send_messages: send_messages,
      manage_users:manage_users,
      stats_page: stats_page,
      upload_contacts: upload_contacts,
      form_components: form_components,
      form_elements: form_elements,
      Modal,
      BaseAlert,
      this_contact: this_contact,
      quick_replies: quick_replies
    },
    /*
    //idk what the difference between props and data is but cant have both it seems
    props: {
      messages_sent: {type:Number,required:true}
    },
    */
    data: function() {
      return {
        default_limit: 50,
        loading_init_data: true,
        init_data_loaded:false,
        active_tab_name: 'home',
        update_backdoor: 0,
        is_debug: false,
        use_this_api_domain: 'fullstackapp-dot-smiling-garden-126003.appspot.com',
        use_this_api_beta_domain: 'fullstackdev-dot-smiling-garden-126003.appspot.com',
        //front_team_id: null,
        //front_teammember_id: null,
        front_conversation_id: "",
        outbound_campaign_type: "SMS",
        active_outbound_campaign_uuid: null,
        currently_setting_this_active_list_uuid: null,
        currently_setting_this_active_script_uuid: null,
        is_fetching_new_contacts:false,
        custom_user_message_body: null,
        init_timestamp: new Date().getTime(),
        max_request_queue_contacts_number: 50,
        queue_contacts_track_requests:0,
        //TODO load the defaults how should we? need to do get org by user, user check permissions
        //TODO do we want to set a time limit to re-get active_org and user even if it's already in storage?
        //e.g. what happens if a user is setup to inactive or permissions change? will the login tool i use take care of invalidating the session? 
        active_user_jwt: "",
        active_org: {
          org_id: null,
          front_team_id: null,
          date_created: null,
          is_active: true,
          last_modified: null,
          org_api_key: null,
          org_name: null
        },
        active_user: {
          "org_id":null,
          "user_uuid":null,
          "first_name":null,
          "last_name":null,
          "email":null,
          "fb_uuid":null,
          "permissions":[
            
          ],
          "admin":true,
          "front_teammember_id":null,
          "cell_phone":null,
          "is_active":null,
          "last_seen":null,
          "date_created":null,
          "last_modified":null,
        },
        active_campaign: {
          org_id:null,
          campaign_name:null,
          outbound_campaign_uuid:null,
          outbound_campaign_type: null,
          scripts:null,
          is_active: null,
          date_created: null,
          last_modified:null,
          list_uuids:null,
          user_uuid_created: null,
          user_uuid_last_modified: null
          //status: "sent" //TODO ?????
        },
        active_script: {
          org_id: null,
          script_uuid:null,
          script_name:null,
          script_type:null,
          script_description: null,
          script_description:null,
          script_text_fallback:null,
          script_text_handlebars:null,
          sms_attachment:null,
          is_active:null,
          date_created: null,
          last_modified: null,
          user_uuid_created:null,
          user_uuid_last_modified:null
        },
        active_list: {
          org_id: null,
          list_uuid: null,
          list_type:null,
          list_name:null,
          is_active:null,
          date_created: null,
          last_modified:null,
          user_uuid_created: null,
          user_uuid_last_modified: null
        },
        active_contact: helpers.empty_active_contact(),
        active_message: null,
        custom_message_body: null,
        custom_message_sms_attachment: null,

        active_messenger_service: {
          org_id:null,
          account_sid:null,
          messaging_service_sid:null,
          numbers: null,
          phone_number_sids: null,
          is_active:null,
          messenger_service_name: null
        },
      
        
        /* //TODO do we need this? i think it only uses the actual number in our api not the pn sid
          numbers: [
            {
              phone_number_sid: "PN91511ff4a968f2526820b5a68c8fedc3",
              friendly_name: "mi vecino (727) 722-8585",
              phone_number: "+17277228585",
              date_created: "2021-05-26T00:06:16.714567Z",
              date_updated: "2021-05-26T00:06:16.714567Z",
              is_active: true
            }
          ]
        */
        
        stats: {
          messages_sent: 1992,
          messages_sent_string: "1992",
          messages_failed: 0,
          messages_skipped:0,
          count_bounced_this_month: "0",
          summary_all_these_send_stats: {
            delivered:0,
            sent:0,
            delivery_unknown:0,
            undelivered:0,
            failed:0
          },
          messages_sent_this_session: 0,
          messages_this_month: {
            count_all_accepted: null,
            count_all_error: null,
            count_sent_to: null
          },
          survey_question_answers: [],
          outbound_campaigns_complex_stats: {},
          all_time_outbound_campaigns_complex_stats: {},
          has_already_loaded_all_time_outbound_campaigns_complex_stats: false
        },
        fetching_stats_status: {
          survey_questions:false,
          complex_twilio_stats:false,
          outbound_messages:false
        },

        delivery_rows: [],


        stats_backdoor:0,

        outbound_campaigns: [],
        outbound_campaigns_stats: [],
        scripts: [],
        survey_questions: [],
        quick_replies: [],
        available_quick_replies: [],
        available_quick_reply_uuids: [],

        contact_lists: [],
        contact_lists_stats: [],
        contact_survey_questions_answers: [],
        is_getting_contact_survey_questions_answers: false,
        message_services: [],
        contacts: [],
        users: [],
      //  array_of_numbers: [],
        array_of_number_messenger_services: [],
        permissions: {
          users: ["create","read"],
          scripts:["create","read"],
          lists:["create","read"],
          contacts:["create","read","read_bulk"],
          campaigns:["create","read","launch"],
          messages:["send","send_bulk","reply"],
          twilio:["read","create","admin"],
          quick_replies:["read","create","send"],
          survey_questions:["create","read","answers_create","answers_read"],
          accounts: ["read"]
        },
        this_vue_data_front_context: {},
        mock_front_context: {"id":"092921d2-1dd8-40d5-b15a-b686bd896e58","entryPointId":"plugin","hostId":"bb56c66f-0704-4914-9096-2eb4db8bfca2","functionArities":{"createWidget":2,"destroyWidget":2,"sendHttp":2,"search":2,"listTeammates":2,"listInboxes":2,"listChannels":2,"listTags":2,"openUrl":2,"openUrlInPopup":3,"createDraft":2,"updateDraft":3,"addTopic":3,"assign":2,"move":2,"setStatus":2,"tag":2,"untag":2,"listMessages":2,"fetchDraft":2},"preferences":{"url":"https://storage.googleapis.com/4degrees_assets/fullstack_app_dev/211030_1/index.html","authSecret":"6b832b8c88f14789","features":["device:microphone","device:camera","device:fullscreen","device:clipboard"]},"teammate":{"id":"tea_3k6s1","name":"Dillon Doyle","username":"dillon","email":"fdp@4degre.es"},"type":"singleConversation","conversation":{"id":"cnv_ewqnbo1","type":"email","status":"open","subject":"You ready for this election?!","blurb":"Registering to vote is #1. But there is so much more to do, Dillon. Do you want to get more involved in our campaign to beat Trump in Florida?","assignee":{"id":"tea_3k6s1","name":"Dillon Doyle","username":"dillon","email":"fdp@4degre.es"},"recipient":{"handle":"dillondoyle@gmail.com","contact":{"id":"crd_1k6rdch","name":"Dillon Doyle","groupIds":[],"handles":[{"type":"email","handle":"dillondoyle@gmail.com"},{"type":"phone","handle":"+16128653082"}],"customAttributes":[{"id":"fld_1wup","name":"zip","type":"string","value":"80218"},{"id":"fld_1x01","name":"address","type":"string","value":"1205 lafayette street"},{"id":"fld_1x5d","name":"party","type":"string","value":"D"},{"id":"fld_1xg1","name":"birthday","type":"string","value":"05/08/1989"},{"id":"fld_1xn5","name":"sms_optin","type":"boolean","value":true},{"id":"fld_1xqp","name":"first_name","type":"string","value":"Dillon"},{"id":"fld_1xsh","name":"last_name","type":"string","value":"Doyle"}]}},"inboxes":[{"id":"inb_6huhd","ownerId":"tim_2r841","name":"test gmail inbox"}],"tags":[{"id":"tag_18z5ld","ownerId":"tea_3k6s1","name":"Inbox"}],"topics":[]}},
        is_processing_get_contact: false,
        has_contact_data: false,
        this_front_conversation_sent_to_number: null,
        contact_data: {
          actblue_sum:{},
          actblue:[],
          incoming_messages:[],
          outbound_messages:[],
          merged_messages: [],
          contact_lists_data:{},
          survey_question_answers: []
        },
        last_computed_sent_to_number: null,
        is_inside_front_plugin: false,
        this_conversation_contact_last_sent_campaign_message: {
          "org_id":null,
          "sent_to":null,
          "date_created":null,
          "script_uuid":null,
          "outbound_campaign_uuid":null,
          "body":'Unable to preview this message',
          "status":null,
          "sent":false,
          "contact_uuid":null,
          "message_sid":null,
          "message_uuid":null,
          "user_uuid_created":null,
          "num_media":null,
          "subresource_uris_media":null,
          "date_updated":null,
          "num_segments":null,
          "script_name":'Unable to find script name.',
          "script_description":null,
          "script_type":null,
          "script_text_fallback":null,
          "script_text_handlebars":null,
          "last_modified":null,
          "is_active":false,
          "sms_attachment":null,
          "campaign_name":null,
          "outbound_campaign_type":null,
          "messaging_service_sid":null,
          "from":null
        },
        this_conversation_contact_last_incoming_message: {
          "org_id":null,
          "messaging_service_sid":null,
          "phone_number_sid":null,
          "phone_number":null,
          "message_sid":null,
          "message_uuid":null,
          "body":'Unable to preview this message',
          "date_created":null,
          "error_code":null,
          "from":null,
          "num_media":null,
          "status":null,
          "to":null,
          "subscribe_request":null,
          "unsubscribe_request":null,
          "sms_message_sid":null,
          "from_city":null,
          "from_zip":"55431",
          "from_state":null,
          "opt_out_type":null,
          "message_status":null,
          "date_updated":null,
          "log_uuid":null,
        },
     
          
        
      }//return
     
      

    },//data
    computed: {
     // these_campaigns_total_sent: function() {
      //  outbound_campaigns_stats
      //},
      array_of_numbers: function() {
        let available_numbers = []
        if(this.active_messenger_service && this.active_messenger_service.numbers && this.active_messenger_service.numbers.length > 0) {

          this.active_messenger_service.numbers.forEach(number => {
            available_numbers.push(number)
           // console.log('debug copute array of numbers push ' + number)
          });

          available_numbers = [...new Set(available_numbers)];

        }
        
        return available_numbers
      },

      messenger_service_numbers_to_messenger_service_sid: function() {
        
        try {
          let object_of_numbers = {}

          if(typeof this.message_services !== 'undefined' && this.message_services &&  this.message_services.length && this.message_services.length > 0) {
            
            this.message_services.forEach((messenger_service_object,index) => {
              if(typeof messenger_service_object.numbers !== 'undefined' && messenger_service_object.numbers && Array.isArray(messenger_service_object.numbers) === true && messenger_service_object.numbers.length > 0)  {

                messenger_service_object.numbers.forEach((single_number,index) => {
                  //console.log(single_number)
                  if (single_number in object_of_numbers) {
                    console.log('number already belongs to a messenger service sid?')
                    console.log(single_number)
                    console.log(JSON.stringify(messenger_service_object))
                  } else {
                    object_of_numbers[single_number] = {messaging_service_sid:messenger_service_object.messaging_service_sid, account_sid: messenger_service_object.account_sid}
                   
                  }
                })
                
              }
              
            })
          }
          
        } catch(e) {
          console.log(e)
        }
      },
      active_outbound_campaigns: function() {
        let active_array = []
        if(typeof this.outbound_campaigns !== 'undefined' && this.outbound_campaigns.length && this.outbound_campaigns.length > 0 ) {
          this.outbound_campaigns.forEach(single_campaign => {
            if(single_campaign.is_active && single_campaign.is_active === true) {
              active_array.push(single_campaign)
            }
          });
        }
        return active_array
      },
       
      vue_context_empty: function() {
        //console.log('debug vue_context_empty')
        //console.log(JSON.stringify(this.this_vue_data_front_context))
        return this.is_object_empty(this.this_vue_data_front_context)
      },
      available_lists_for_this_campaign: function() {

        try {
          //PROBLEM is timing i think? 
        //console.log('debug available_lists_for_this_campaign wait for next tick')
        //this.$nextTick(() => {
          //console.log('debug available_lists_for_this_campaign next tick')
          if(!this.active_campaign ) {
            console.log('timing 380 no active campaign')
            return []
          } else {
            var this_available_lists = []
            var these_list_uuids = []

            if(!this.contact_lists || !this.contact_lists.length || this.contact_lists.length === 0) {
              this.$nextTick(() => {
                
                
                if(this.active_campaign && this.active_campaign.list_uuids) {
                  if(this.active_campaign.list_uuids.length && this.active_campaign.list_uuids.length > 0) {
                    //use the scripts[] to loop and grab available script names
                    
                    for (let i = 0; i < this.active_campaign.list_uuids.length; i++) {
                      //console.log('this active_campaign list_uuid')
                      for (let b = 0; b < this.contact_lists.length; b++) {
                        
                        //console.log('debug does this.active_campaign.list_uuids[i] ' + this.active_campaign.list_uuids[i] + ' match this.contact_lists[b].list_uuid ' + this.contact_lists[b].list_uuid)
                        if(this.active_campaign.list_uuids[i] === this.contact_lists[b].list_uuid) {

                          //console.log('debug 381 current lists already has this active campaign list_uuid ')
                          
                          //console.log('array of available lists for this campaign:')
                          //console.log(JSON.stringify(these_list_uuids))
                          //same fucking bug i am too tired why is this happening to me
                          if(!these_list_uuids.includes(this.active_campaign.list_uuids[i])) {
                          //console.log('array of availalble lists does not contain the current loop list_uuid')
                            //make sure is active
                            if(this.contact_lists[b].is_active === true) {
                              //console.log('this contact list is set to active push into the available lists')
                              these_list_uuids.push(this.active_campaign.list_uuids[i])
                              //console.log(JSON.stringify(these_list_uuids))

                              //console.log('match list_uuids ' + this.active_campaign.list_uuids[i] + ' ' + this.contact_lists[b].list_uuid)
                              this_available_lists.push({
                                list_uuid: this.contact_lists[b].list_uuid,
                                list_name: this.contact_lists[b].list_name
                              })
                            }
                          }
                        
                          
                        }
                      }
                    }
                    
                  }
                }

                return this_available_lists
              })
            } else {
              //TODO remove this dupe code just call a function on settimeout
              
              if(this.active_campaign && this.active_campaign.list_uuids) {
                if(this.active_campaign.list_uuids.length && this.active_campaign.list_uuids.length > 0) {
                  //use the scripts[] to loop and grab available script names
                  
                  for (let i = 0; i < this.active_campaign.list_uuids.length; i++) {
                    //console.log('this active_campaign list_uuid')
                    for (let b = 0; b < this.contact_lists.length; b++) {
                      
                      //console.log('debug does this.active_campaign.list_uuids[i] ' + this.active_campaign.list_uuids[i] + ' match this.contact_lists[b].list_uuid ' + this.contact_lists[b].list_uuid)
                      if(this.active_campaign.list_uuids[i] === this.contact_lists[b].list_uuid) {

                        //console.log('debug 381 current lists already has this active campaign list_uuid ')
                        
                      // console.log('array of available lists for this campaign:')
                        //console.log(JSON.stringify(these_list_uuids))
                        //same fucking bug i am too tired why is this happening to me
                        if(!these_list_uuids.includes(this.active_campaign.list_uuids[i])) {
                        //console.log('array of availalble lists does not contain the current loop list_uuid')
                          //make sure is active
                          if(this.contact_lists[b].is_active === true) {
                            //console.log('this contact list is set to active push into the available lists')
                            these_list_uuids.push(this.active_campaign.list_uuids[i])
                            //console.log(JSON.stringify(these_list_uuids))

                            //console.log('match list_uuids ' + this.active_campaign.list_uuids[i] + ' ' + this.contact_lists[b].list_uuid)
                            this_available_lists.push({
                              list_uuid: this.contact_lists[b].list_uuid,
                              list_name: this.contact_lists[b].list_name
                            })
                          }
                        }
                      
                        
                      }
                    }
                  }
                  
                }
              }
            }  
          
            return this_available_lists

          }
        } catch(e) {
          console.log(e)
          return []
        }
        
        //})
        
        
      },
      available_scripts_for_this_campaign: function() {
        try {
         
          var this_available_scripts = []
          var these_script_uuids = []
          if(this.active_campaign && this.active_campaign.scripts && this.scripts && this.scripts.length && this.scripts.length > 0) {
            if(this.active_campaign.scripts.length && this.active_campaign.scripts.length > 0 ) {
              //use the scripts[] to loop and grab available script names
              
              for (let i = 0; i < this.active_campaign.scripts.length; i++) {
              //  console.log('debug 978 single active_campaign script_uuid')
                
                for (let b = 0; b < this.scripts.length; b++) {
     
                  if(this.active_campaign.scripts[i] === this.scripts[b].script_uuid) {
                    
                    //210901 idk why there is a bug that over rights this.scripts each script_uuid to be the same one? so add a double check here
                    if(!these_script_uuids.includes(this.active_campaign.scripts[i])) {
                    //  console.log('match debug script make it available ' + this.active_campaign.scripts[i] + ' ' + this.scripts[b].script_uuid)
                      
                      //make sure is active
                      if(this.scripts[b].is_active === true) {
                        this_available_scripts.push({
                          script_uuid: this.active_campaign.scripts[i],
                          script_name: this.scripts[b].script_name
                        })
                        these_script_uuids.push(this.active_campaign.scripts[i])
                      }
                      
                    }
                    
                  }

                }
              }
              
            }
          } else {
            //TODO is there a way to shorten all these stupid tick hacks?
            this.$nextTick(() => {
              if(this.active_campaign && this.active_campaign.scripts && this.scripts && this.scripts.length && this.scripts.length > 0) {
                if(this.active_campaign.scripts.length && this.active_campaign.scripts.length > 0 ) {
                  //use the scripts[] to loop and grab available script names
                  
                  for (let i = 0; i < this.active_campaign.scripts.length; i++) {
                   // console.log('debug 978 single active_campaign script_uuid')
                    
                    for (let b = 0; b < this.scripts.length; b++) {
        
                      if(this.active_campaign.scripts[i] === this.scripts[b].script_uuid) {
                        
                        //210901 idk why there is a bug that over rights this.scripts each script_uuid to be the same one? so add a double check here
                        if(!these_script_uuids.includes(this.active_campaign.scripts[i])) {
                        //  console.log('match debug script make it available ' + this.active_campaign.scripts[i] + ' ' + this.scripts[b].script_uuid)
                          
                          //make sure is active
                          if(this.scripts[b].is_active === true) {
                            this_available_scripts.push({
                              script_uuid: this.active_campaign.scripts[i],
                              script_name: this.scripts[b].script_name
                            })
                            these_script_uuids.push(this.active_campaign.scripts[i])
                          }
                          
                        }
                        
                      }

                    }
                  }
                  
                }
              }
            })
          }

          return this_available_scripts
        } catch(e)  {
          console.log(e)
          return []
        }
        
      },
      
     
      active_campaign_uuid_for_watch: function() {
        if(this.active_campaign && this.active_campaign.outbound_campaign_uuid !== null) {
          //console.log('debug time 521 watch active_campaign_uuid_for_watch exists return')
          return this.active_campaign.outbound_campaign_uuid
        } else {
         // console.log('debug time 521 watch active_campaign_uuid_for_watch does not exist return null')
          return null
        }
        
      },


      rendered_message_sms_attachment:function() {

        if (this.active_script && this.active_script.script_uuid !== null) {
          if(typeof this.active_script.sms_attachment !== 'undefined' && this.active_script.sms_attachment !== null && this.active_script.sms_attachment !== '') {
            //create an object that it can parse like active_user.first_name active_contact.first_name
            let create_data_object = {
              active_user: this.active_user,
              active_contact: this.active_contact,
              custom_data: null
            }
            //console.log(create_data_object)
            

            //2210 add custom contact data
            try {
              if (typeof this.active_contact !== 'undefined' && typeof this.active_contact.json_contact_data !== 'undefined' && this.active_contact.json_contact_data !== null && this.active_contact.json_contact_data !== '') {
                //console.log('this.active_contact.json_contact_data')
                //console.log(this.active_contact.json_contact_data)
                if (typeof this.active_contact.json_contact_data === 'string') {
                  create_data_object.custom_data = JSON.parse(atob(this.active_contact.json_contact_data))
                  //console.log(create_data_object.custom_data)
                } else {
                  console.log('has data but is not a string? ' + typeof this.active_contact.json_contact_data)
                  console.log(this.active_contact.json_contact_data)
                }
              }
            } catch(e) {
              console.log(e)
            }

            try {
              //console.log(JSON.stringify(create_data_object))

              let template = handlebars.compile(this.active_script.sms_attachment + '');

              let this_attachment = template(create_data_object);

              //in case handlebars has Error
              if (typeof template === 'string' && template.toUpperCase().includes('ERROR')) {
                console.log('error gen sms_attachment')
                console.log(template)
                return this.active_script.sms_attachment || null
              }

              //console.log('this_attachment')
              //console.log(this_attachment)

              return this_attachment

            } catch (e) {
                console.log(e)
                return this.active_script.sms_attachment || null
            }
          }
        } else {
            return null
        }
      },

                  /*
          set: function() {
            try {
              this.$nextTick(() => {
                  
              })

            } catch (e) {
              console.log(e)
              return null
            }

          },
          get: function() {
            try {
              this.$nextTick(() => {
                  if (this.active_script && this.active_script.script_uuid !== null) {
                    if(typeof this.active_script.sms_attachment !== 'undefined' && this.active_script.sms_attachment !== null && this.active_script.sms_attachment !== '') {
                      //create an object that it can parse like active_user.first_name active_contact.first_name
                      let create_data_object = {
                        active_user: this.active_user,
                        active_contact: this.active_contact,
                        custom_data: null
                      }

                      //2210 add custom contact data
                      try {
                        if (typeof this.active_contact !== 'undefined' && typeof this.active_contact.json_contact_data !== 'undefined' && this.active_contact.json_contact_data !== null && this.active_contact.json_contact_data !== '') {
                          console.log('this.active_contact.json_contact_data')
                          console.log(this.active_contact.json_contact_data)
                          if (typeof this.active_contact.json_contact_data === 'string') {
                            create_data_object.custom_data = JSON.parse(atob(this.active_contact.json_contact_data))
                            console.log(create_data_object.custom_data)
                          } else {
                            console.log('has data but is not a string? ' + typeof this.active_contact.json_contact_data)
                            console.log(this.active_contact.json_contact_data)
                          }
                        }
                      } catch(e) {
                        console.log(e)
                      }

                      try {
                        console.log(JSON.stringify(create_data_object))
                        let template = handlebars.compile(this.active_script.sms_attachment + '');

                        let this_attachment = template(create_data_object);

                        //in case handlebars has Error
                        if (typeof template === 'string' && template.toUpperCase().includes('ERROR')) {
                          console.log('error gen sms_attachment')
                          console.log(template)
                          return this.active_script.sms_attachment || null
                        }

                        console.log('this_attachment')
                        console.log(this_attachment)
                        return this_attachment

                      } catch (e) {
                          console.log(e)
                          return this.active_script.sms_attachment || null
                      }
                    }
                  } else {
                      return null
                  }
              })

            } catch (e) {
              console.log(e)
              return null
            }
          }
          */
  

      rendered_message_body: function() {
        try {

          if (this.active_script && this.active_script.script_uuid !== null) {

              //create an object that it can parse like active_user.first_name active_contact.first_name
              let create_data_object = {
                active_user: this.active_user,
                active_contact: this.active_contact,
                custom_data: null
              }

              //console.log(create_data_object)

              //2210 add custom contact data
              try {
                if (typeof this.active_contact !== 'undefined' && typeof this.active_contact.json_contact_data !== 'undefined' && this.active_contact.json_contact_data !== null && this.active_contact.json_contact_data !== '') {
                  //console.log('this.active_contact.json_contact_data')
                  //console.log(this.active_contact.json_contact_data)
                  if (typeof this.active_contact.json_contact_data === 'string') {
                    create_data_object.custom_data = JSON.parse(atob(this.active_contact.json_contact_data))
                    //console.log(create_data_object.custom_data)
                  } else {
                    console.log('has data but is not a string? ' + typeof this.active_contact.json_contact_data)
                    console.log(this.active_contact.json_contact_data)
                  }
                }
              } catch(e) {
                console.log(e)
              }

              try {

                let template = handlebars.compile(this.active_script.script_text_handlebars + '');

                let this_script = template(create_data_object);

                //in case handlebars has Error
                if (typeof template === 'string' && template.toUpperCase().includes('ERROR')) {
                    return this.active_script.script_text_fallback
                }

                //console.log(this_script)

                return this_script || null

              } catch (e) {
                  console.log(e)
                  return this.active_script.script_text_fallback
              }

          } else {
              return null
          }


      //console.log(this.active_script.script_text_handlebars)
      //console.log(this.active_contact)

      } catch (e) {
        console.log(e)
        return null
      }
    }
        /*
        //TODO bug this isn't updating when user ata is changed on the contact in send_messages.vue
        set: function() {
            
        },
        get: function() {
          try {
            this.$nextTick(() => {
                if (this.active_script && this.active_script.script_uuid !== null) {

                    //create an object that it can parse like active_user.first_name active_contact.first_name
                    let create_data_object = {
                      active_user: this.active_user,
                      active_contact: this.active_contact,
                      custom_data: null
                    }

                    //2210 add custom contact data
                    try {
                      if (typeof this.active_contact !== 'undefined' && typeof this.active_contact.json_contact_data !== 'undefined' && this.active_contact.json_contact_data !== null && this.active_contact.json_contact_data !== '') {
                        console.log('this.active_contact.json_contact_data')
                        console.log(this.active_contact.json_contact_data)
                        if (typeof this.active_contact.json_contact_data === 'string') {
                          create_data_object.custom_data = JSON.parse(atob(this.active_contact.json_contact_data))
                          console.log(create_data_object.custom_data)
                        } else {
                          console.log('has data but is not a string? ' + typeof this.active_contact.json_contact_data)
                          console.log(this.active_contact.json_contact_data)
                        }
                      }
                    } catch(e) {
                      console.log(e)
                    }

                    try {

                      let template = handlebars.compile(this.active_script.script_text_handlebars + '');

                      let this_script = template(create_data_object);

                      //in case handlebars has Error
                      if (typeof template === 'string' && template.toUpperCase().includes('ERROR')) {
                          return this.active_script.script_text_fallback
                      }

                      return this_script

                    } catch (e) {
                        console.log(e)
                        return this.active_script.script_text_fallback
                    }

                } else {
                    return null
                }
            })

            //console.log(this.active_script.script_text_handlebars)
            //console.log(this.active_contact)

            } catch (e) {
            console.log(e)
            return null
            }

        }
        */

    },
    watch: {
      active_contact: {
        handler: function(newVal,oldVal) {
          //220829 debug
          //console.log('debug watch active_contact updated')
          if(newVal && newVal !== null && typeof newVal !== 'undefined') {
            this.generate_active_message()
          }
        }
      },

      stats_backdoor: {
        
        handler: function(newVal,oldVal) {
          if(newVal !== null) {
            let count_delivered = 0
            let count_sent = 0
            let count_delivery_unkown = 0
            let count_undelivered = 0
            let count_failed = 0

            try {

              if(typeof this.stats.outbound_campaigns_complex_stats !== 'undefined') {
                for (var outbound_campaign_uuid in this.stats.outbound_campaigns_complex_stats) {
                  if (this.stats.outbound_campaigns_complex_stats.hasOwnProperty(outbound_campaign_uuid)) {
                    if(this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid].length && this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid].length > 0) {
                      this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid].forEach(script_row => {
                          if(typeof script_row.delivered !== 'undefined' && script_row.delivered !== null) {
                            count_delivered = count_delivered + script_row.delivered
                          }
                          if(typeof script_row.sent !== 'undefined' && script_row.sent !== null) {
                            count_sent = count_sent + script_row.sent
                          }
                          if(typeof script_row.delivery_unkown !== 'undefined' && script_row.delivery_unkown !== null) {
                            count_delivery_unkown = count_delivery_unkown + script_row.delivery_unkown
                          }
                          if(typeof script_row.undelivered !== 'undefined' && script_row.undelivered !== null) {
                            count_undelivered = count_undelivered + script_row.undelivered
                          }
                          if(typeof script_row.failed !== 'undefined' && script_row.failed !== null) {
                            count_failed = count_failed + script_row.failed
                          }
                      });
                    }

                  }   
                  
                }
              }

              if(this.stats.has_already_loaded_all_time_outbound_campaigns_complex_stats !== true) {
                if(typeof this.stats.all_time_outbound_campaigns_complex_stats !== 'undefined') {
                  for (var outbound_campaign_uuid in this.stats.all_time_outbound_campaigns_complex_stats) {
                    if (this.stats.all_time_outbound_campaigns_complex_stats.hasOwnProperty(outbound_campaign_uuid)) {
                      if(this.stats.all_time_outbound_campaigns_complex_stats[outbound_campaign_uuid].length && this.stats.all_time_outbound_campaigns_complex_stats[outbound_campaign_uuid].length > 0) {
                        this.stats.all_time_outbound_campaigns_complex_stats[outbound_campaign_uuid].forEach(script_row => {
                            if(typeof script_row.delivered !== 'undefined' && script_row.delivered !== null) {
                              count_delivered = count_delivered + script_row.delivered
                            }
                            if(typeof script_row.sent !== 'undefined' && script_row.sent !== null) {
                              count_sent = count_sent + script_row.sent
                            }
                            if(typeof script_row.delivery_unkown !== 'undefined' && script_row.delivery_unkown !== null) {
                              count_delivery_unkown = count_delivery_unkown + script_row.delivery_unkown
                            }
                            if(typeof script_row.undelivered !== 'undefined' && script_row.undelivered !== null) {
                              count_undelivered = count_undelivered + script_row.undelivered
                            }
                            if(typeof script_row.failed !== 'undefined' && script_row.failed !== null) {
                              count_failed = count_failed + script_row.failed
                            }
                        });
                      }

                    }   
                    
                  }
                }

                this.stats.has_already_loaded_all_time_outbound_campaigns_complex_stats = true
              }
              

            } catch(e) {
              console.log(e)
            }

            let combined_bounces = (count_undelivered+count_failed) || 0
            this.stats.count_bounced_this_month = combined_bounces.toString()

            this.stats.summary_all_these_send_stats = {
              delivered:count_delivered || 0,
              sent:count_sent || 0,
              delivery_unknown:count_delivery_unkown || 0,
              undelivered:count_undelivered || 0,
              failed:count_failed || 0
            }

            this.generate_stats_delivery_rows()
            
          }
        }

      },  
     
      
      this_vue_data_front_context: {

        handler: function(newVal,oldVal) {
          //console.log('debug 860 new this_vue_data_front_context')
          //console.log(JSON.stringify(newVal))
          
          if(newVal && newVal !== oldVal) {
            if(newVal === null ) {
              console.log('debug this_vue_data_front_context newVal is null oor empty object')
              this.clear_is_pulling_this_contact()
            } else {
              //console.log(newVal.type)
              //console.log(this.init_data_loaded)


              let grab_this_contact = (passed_sent_to,recursive_count) => {
                let use_this_sent_to = null

                if(typeof passed_sent_to !== 'undefined') {
                  use_this_sent_to = passed_sent_to
                } else {
                  if(typeof this.this_front_conversation_sent_to_number !== 'undefined' && this.this_front_conversation_sent_to_number !== null) {
                    use_this_sent_to = this.this_front_conversation_sent_to_number
                  } else {
                    console.log('debug 942 sohuldnt be here')
                  }
                }

                //console.log('this.this_front_conversation_sent_to_number ' + this.this_front_conversation_sent_to_number)
                if(use_this_sent_to !== null) {
                 
                  if(this.is_processing_get_contact === false) {
                    this.is_processing_get_contact = true
                    
                    let limits = {
                        outbound_messages: 8,
                        incoming_messages: 8,
                        actblue_donations: 10
                    }
                    let fields = [
                        'CONTACT_LISTS_DATA',//JOIN AND DEDUPE BY LIST? 
                        'ACTBLUE_SUM',
                        'ACTBLUE_DONATIONS',
                        'OUTBOUND_MESSAGES', //JOIN TO PHONE_NUMBERS ?
                        'INCOMING_MESSAGES'
                    ]

                    let sent_to_array = [this.this_front_conversation_sent_to_number]
                    
                    this.get_contact_stats(sent_to_array,fields, limits, this.active_org.org_id, this.active_user.user_uuid)

                    //220610 moved to if success get_contact_stats
                    
                    
                  } else {
                    console.log('debug already fetching contact?')
                    let call_recursive = true
                    if(typeof recursive_count !== 'undefined' && recursive_count !== null) {
                      console.log('recursive_count ' + recursive_count)
                      if(recursive_count > 1) {
                        call_recursive = false
                        
                      }
                    }

                    if(call_recursive === true) {
                      if(typeof recursive_count === 'undefined' || recursive_count === null) {
                        console.log('debug no recursive_count')
                        recursive_count = 0
                      }
                      console.log('debug call recursive 1058')

                      setTimeout(() => {
                        grab_this_contact(passed_sent_to,recursive_count+1)
                      }, 1000*recursive_count);
                      
                    }
                  }

                } else {
                  console.log('missing a sent_to number variable? 952')

                }
              }//grab_this_contact funtion
              
              let verify_number_length_then_next = (number_substring) => {

                //if(typeof count_attempts && count_attempts !== null && count_attempts < 2) {
                  //this_front_conversation_sent_to_number
                  //calculate_this_front_conversation_sent_to_number
                  let use_this_sent_to_check = this.calculate_this_front_conversation_sent_to_number()


                  if(!use_this_sent_to_check || use_this_sent_to_check === null || !use_this_sent_to_check.length || use_this_sent_to_check.length < 10) {
                    //console.log('conversation number not long enough ' + use_this_sent_to_check || null)
                    //grab by body from twilio logs

                    //console.log('this.this_vue_data_front_context.conversation')
                    //console.log(JSON.stringify(this.this_vue_data_front_context.conversation))

                    let the_body = this.this_vue_data_front_context.conversation.blurb || null


                    if(!the_body || !the_body.length && the_body.length < 10) {
                      console.log('this conversation blurb body to short to match?')
                      return
                    }

                    if(typeof this.active_org.org_id === 'undefined') {
                      console.log('debug 914 missing org_id?')
                    }

                    let use_number_substring = 15
                    if(typeof number_substring !== 'undefined' && number_substring !== null) {
                      use_number_substring = number_substring
                    }

                    let select_params = {
                      body:the_body.substring(0,number_substring),
                      org_id: this.active_org.org_id,
                      //hash_sent_to_body: the_body
                      //body_base_64: safe_buffer.from(the_body).toString('base64')
                    }

                    if(use_this_sent_to_check && use_this_sent_to_check !== null) {
                      if(use_this_sent_to_check === '%2' || use_this_sent_to_check === '+1') {
                        console.log('debug 918 doesnt have enough number to add into the object')
                      } else {
                        //make sure starts with +1
                        if(use_this_sent_to_check.startsWith('+1')) {
                          console.log('has at least a couple add it into the select')
                          //i think able to use the first section?
                          select_params.from = use_this_sent_to_check.toString()
                        } 
                        
                      }
                    }

                    this.grab_twilio_log(select_params,grab_this_contact) //get_vars,callback_function
                  } else {
                    this.this_front_conversation_sent_to_number = use_this_sent_to_check
                    grab_this_contact()
                  }

                //} else {
                //  console.log('attempted too may do nothing count_attempts ' + count_attempts)
                //}

              }

              if(newVal.type === 'singleConversation' && this.init_data_loaded === true) {
                verify_number_length_then_next(15)
              } else {
                setTimeout(() => {
                  //console.log(this.init_data_loaded)
                  if(newVal.type === 'singleConversation' && this.init_data_loaded === true) {
                    //console.log('debug 893 going to grab_this_contact')
                      //grab_this_contact()
                      verify_number_length_then_next(15)
                    }
                }, 5000);
              }
            }
          }
          }
          
          
      },
      
      active_outbound_campaign_uuid: { //?? active_campaign_uuid_for_watch
        handler: function(newVal,oldVal) {
          if(this.loading_init_data === false) {
            this.cascade_updates_on_new_active_campaign(null,null,0,1000,newVal)
            //this.cascade_updates_on_new_active_campaign()
          }
          
        }
      },
      this_front_conversation_sent_to_number: {
        handler: function(newVal,oldVal) {
          if(newVal && newVal !== null && newVal !== oldVal) {
            //220610 get this contact's survey question responses

            //TODO should do this here ? or bundle into the merged get this contact function?
            if(newVal.length && ( newVal.length === '12' || newVal.length === 12) ) {

              if(this.is_getting_contact_survey_questions_answers === false) {
                this.is_getting_contact_survey_questions_answers = true
                try {
                  axios.get('https://'+this.use_this_api_domain+'/stats/contact_lists', { 
                    params: {
                      org_id: this.active_user.org_id,
                      sent_to:newVal,
                      limit_result: 50
                    },
                    headers: {
                      'Authorization': 'Bearer ' + this.active_user_jwt
                    }
                  })
                  .then((results,error) => {
                    if(results) {
                      if(results.status === 200) {

                        this.contact_survey_questions_answers = helpers.merge_array_of_objects(this.contact_survey_questions_answers,results.data,'survey_question_answer_uuid') //(original, newdata, selector = 'key') 

                      }
                    } else {
                      this.contact_survey_questions_answers = []
                    }
                    this.is_getting_contact_survey_questions_answers = false
                  })
                  .catch((error) => {
                    
                    if(error) {
                      if(error.response && error.response.status && error.response.status === 404) {

                      } else {
                        console.log(error)
                      }
                      
                    }
                    this.contact_survey_questions_answers = []
                    this.is_getting_contact_survey_questions_answers = false
                  })
                } catch(e) {
                  console.log('error getting survey questions answers for this contact')
                  console.log(e)
                  this.contact_survey_questions_answers = []
                  this.is_getting_contact_survey_questions_answers = false
                }
              } else {
                console.log('debug already getting survey question answers')
                setTimeout(() => {
                  if(this.is_getting_contact_survey_questions_answers === false) {
                    this.this_front_conversation_sent_to_number = this.this_front_conversation_sent_to_number + ''
                  }
                }, 1300);
              }
              
            } else {
              console.log('debug this_front_conversation_sent_to_number not correct?  ' + newVal)
              this.contact_survey_questions_answers = []
              this.is_getting_contact_survey_questions_answers = false
            }

          }
          
        }
      }
   
    },
    mounted:function() {
      //console.log('debug mounted')

      if (location.hostname && ( location.hostname === "localhost" || location.hostname === "localhost:8080") ) {
        //is debug use new app engine url
        this.is_debug =  true
        this.use_this_api_domain = this.use_this_api_beta_domain
      }


      if(typeof handlebars !== 'undefined') {

        handlebars.registerHelper('name_case', function (passed_string) {

          try {
            if(typeof passed_string !== 'string') {
              return null
            }

            passed_string = helpers.toTitleCase(passed_string).replace(/\s\s+/g, ' ')

            if(typeof passed_string === 'string') {
                return passed_string
            } else {
              console.log('handlebars name_case couldnot get a string null it from passed_string: ' + passed_string)
              return null
            }
          } catch(e) {
            console.log('debug handlebars name_case error:')
            console.log(e)
            return null
          }

        })

        handlebars.registerHelper('letters_only', function (passed_string) {

          try {
            if(typeof passed_string === 'string') {
              if(/[^a-zA-Z]+/g.test(passed_string)) {
                return false
              } else {
                return true
              }
            } else {
              console.log('handlebars letters_only is not string?')
              console.log(typeof passed_string)
              console.log(passed_string)
              return false
            }
            
          } catch(e) {
            console.log(e)
            return false
          }

        })

        handlebars.registerHelper('truncate_multi_word', function (passed_string) {
          try {
            if(typeof passed_string !== 'string') {
              return new Error('must be a string')
            }

            passed_string = passed_string.replace('/',' ')
            if(passed_string.includes(', ')) {
              console.log('debug this handlebars has a comma maybe last,first? ' + passed_string)
              passed_string = passed_string.split(', ')[1]
              console.log(passed_string)
            }

            //if is only one or two characters return null
            let return_this = passed_string.split(' ')[0]

            if(return_this.length && return_this.length < 3) {
              console.log('handlebars truncate_multi_word length is less than 3? return_this:')
              console.log(return_this)
              return_this = return_this
            }

            if(typeof return_this !== 'string') {
              console.log('handlebars truncate_multi_word return is not string? return_this:')
              return_this = null
            }

            return return_this
          } catch(e) {
            console.log('handlebars truncate_multi_word error:')
            console.log(e)
            return null
          }

          
        })
      }
      

      //check is inside front plugin
      var url = (window.location != window.parent.location)
                ? document.referrer
                : document.location.href;

      if(url.endsWith('frontapplication.com/') || url.endsWith('frontapplication.com') || this.is_debug === true) {
        this.is_inside_front_plugin = true
      }

      //#JWT
      //check if is in localstorage first
      let this_local_storage_active_user_jwt = localStorage.getItem('active_user_jwt')
      if(this_local_storage_active_user_jwt === null) {
        this_local_storage_active_user_jwt = sessionStorage.getItem('active_user_jwt')
      }

      if(!this_local_storage_active_user_jwt || this_local_storage_active_user_jwt === null || typeof this_local_storage_active_user_jwt === 'undefined' || this_local_storage_active_user_jwt === '') {
        return this.$router.push('login')
      }
      if(this_local_storage_active_user_jwt !== null) {
        let jwt_tokens = this_local_storage_active_user_jwt.split(".");
        let this_stored_user_jwt = JSON.parse(atob(jwt_tokens[1]))

        this.active_user_jwt = this_local_storage_active_user_jwt
        //send a verify request

        //if not verified redirect to login screen
        //if in local storage, append if front teammember_id and then get this user /verify which should return a fresh jwt with last_seen, or return a login prompt to redirect
        this.active_org.org_id = this_stored_user_jwt.org_id
        this.active_user = this_stored_user_jwt

        if(this.active_user && this.active_user.email && this.active_user.email !== null) {
          if(this.active_user.email.toUpperCase() === 'DILLONDOYLE@GMAIL.COM' || this.active_user.email.toUpperCase() === 'DILLON@4DEGRE.ES' ) {
            console.log('debug is dillon use debug domain')
            this.is_debug =  true
            this.use_this_api_domain = this.use_this_api_beta_domain
          }
        }
        
        //mount is firing after the subscribe to front context
        if(this.is_inside_front_plugin) {
          
          setTimeout(() => {

            let subscribe_front_context = () => {

              Front.contextUpdates.subscribe(context => {
                //console.log('front new context update')
                //console.log(JSON.stringify(context))
                if(context && context.conversation && context.conversation.id && context.conversation.id !== null) {
                  //check if matches existing
                  if(this.front_conversation_id !== context.conversation.id) {
                    this.this_vue_data_front_context = JSON.parse(JSON.stringify(context))
                  }
                } else {
                  this.this_vue_data_front_context = null
                  this.clear_is_pulling_this_contact()
                }
                
                //TODO if we want to actually use front_teammember_id check if init_data_loaded so only run once and verify jwt matches this front user
                
              });

            }

            if(this.is_inside_front_plugin === true) {
              if(typeof Front !== 'undefined') {
                subscribe_front_context()
              } else {
                //front script is somehow still not loaded set a time out and then set the context again
                setTimeout(() => {

                  if(typeof Front !== 'undefined') {
                    subscribe_front_context()
                  } else {
                    console.log('waited 10s but front still not loaded?')
                  }

                }, 10000);
              }
            }
            
          }, 500);
        }//end inside front plugin check
        
        //get other requests
        if(this.active_user_jwt) {
          this.get_org_data() // -> goes to other init async requests after success
        } else {
          console.log('shouldnt be here 1149')
          return this.$router.push('login')
        }
        
      } else {
        return this.$router.push('login')
      }

    },
    methods: {
      error_popup: function(message) {
          swal.fire({
              title: `Warning`,
              text: message+'',
              buttonsStyling: false,
              icon: 'warning'
            })
          return new Error(message)
      },
      get_total_campaign_statistics: function(time_before,time_after) {
        console.log('timing parent method to call stats 1283')
        this.get_outbound_campaign_stats(null,null,null)
      },
      generate_stats_delivery_rows: function() {

        try {
          if(typeof this.stats.outbound_campaigns_complex_stats !== 'undefined' && Object.keys(this.stats.outbound_campaigns_complex_stats).length > 0) {

            let parrent_rows_array = []

            for (var outbound_campaign_uuid in this.stats.outbound_campaigns_complex_stats) {
                if (this.stats.outbound_campaigns_complex_stats.hasOwnProperty(outbound_campaign_uuid)) {

                  let found_this_date_created =  null

                  this.outbound_campaigns.forEach(single_campaign => {
                    if(single_campaign.outbound_campaign_uuid === outbound_campaign_uuid) {
                      found_this_date_created = single_campaign.date_created
                    }
                  });

                  if(this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid].length && this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid].length > 0) {

                    /*
                    let this_object_clone = JSON.parse(JSON.stringify(this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid]))

                    this_object_clone.forEach(single_row => {
                      single_row.date_created = found_this_date_created
                    });
                    */

                    parrent_rows_array.push(
                      {
                        id:outbound_campaign_uuid,
                        name:this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid][0].campaign_name,
                        mode:'span',
                        label: this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid][0].campaign_name,
                        html:true,
                        date_created: found_this_date_created,
                        children:this.stats.outbound_campaigns_complex_stats[outbound_campaign_uuid]
                      }
                    )

                  }

                }
            }

            if(parrent_rows_array.length && parrent_rows_array.length > 0) {

              //order by date_created
              parrent_rows_array.sort(function(a, b) {
                var keyA = new Date(a.date_created),
                  keyB = new Date(b.date_created);
                // Compare the 2 dates
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
              });

              this.delivery_rows = parrent_rows_array
            } else {
              console.log('1369')
              this.delivery_rows = []
            }

          } else {
            this.delivery_rows = []
          }

        } catch(e) {
          console.log(e)
          this.delivery_rows = []
        }

      
      },
      get_org_data: function() {
        try {
          if(this.active_user && this.active_user.org_id && this.active_user.org_id !== null) {
     
            axios.get('https://'+this.use_this_api_domain+'/admin/this_org', { 
              params: {
                org_id: this.active_user.org_id,
                limit_result: 1
              },
              headers: {
                'Authorization': 'Bearer ' + this.active_user_jwt
              }
            })
            .then(response => {
                
              if(response.status !== 200) {
                return this.$router.push('login')
                /*
                if(response.status === 403 || response.status === 401 || ( response.data && response.data.authenticated && response.data.authenticated === false ) ) {
                  console.log('not loged in redirect ')
                  return this.$router.push('login')
                }
                console.log("this organization response error:")
                console.log(response.data)
                return this.error_popup('Can not get organization')
                */
              } else {

             
                if(response.data.length !== 1) {
                  return this.error_popup('Error no org or too many orgs returned')
                } else {
                  this.active_org = response.data[0]
                }
              }

              //make sure active_org.is_active is true
              if(this.active_org.is_active !==true) {
                return this.error_popup('This organization is not active or does not exist')
              }

              this.create_init_state_api_requests()

            })
            .catch((error) => {
              if(error.status && error.status === 401) {
                return this.$router.push('login')
              } else {
                return this.$router.push('login')
                //return this.error_popup('Can not get organization contact admin')
              }
            })
          } else {
            return this.$router.push('login')
          }
        } catch(e) {
          console.log(e)
          return this.$router.push('login')
          //return this.error_popup('Can not get organization')
        }
      },
      create_init_state_api_requests:function() {
      
        var array_of_promises = []

        try {
        // console.log('get_user_account function call')
        //TODO add some cache ing

        
          //check  permissions
          if(this.active_user_jwt && this.active_user.permissions && this.active_user.permissions.length && this.active_user.permissions.length > 0) {

            if(this.active_user.permissions.includes('users:read')) {
            
              array_of_promises.push(axios.get('https://'+this.use_this_api_domain+'/admin/users', { 
                params: {
                  org_id: this.active_org.org_id
                },
                headers: {
                   'Authorization': 'Bearer ' + this.active_user_jwt
                }
              })
              .then((response,error) => {
                if(error) {
                  console.log('get user error')
                  console.log(JSON.stringify(error))
                  return this.error_popup("Get user error")
                }
                if(response) {
                  if(response.status === 200) {
                    this.users = response.data
                  } else {
                    return this.error_popup("Get user error")
                  }
                }
              }))
            }

            if(this.active_user.permissions.includes('campaigns:read') || this.active_user.permissions.includes('campaigns:create')) {
              array_of_promises.push(this.get_outbound_campaigns(null,this.get_init_this_month_complex_stats))
            }

            if(this.active_user.permissions.includes('scripts:read')) {
              array_of_promises.push(axios.get('https://'+this.use_this_api_domain+'/scripts/script', { 
                params: {
                  org_id: this.active_org.org_id,
                  script_type:'SMS',
                  limit_results: this.default_limit || 25
                },
                headers: {
                    'Authorization': 'Bearer ' + this.active_user_jwt
                  }
              }).then((results,error) => {
                if(results && results.status === 200 ) {
                  if(results.data && results.data.length && results.data.length >0) {
                    this.scripts = results.data

                  //  console.log('debug timing 857')
                  } else {
                    console.log('debug scripts is empty but shouldnt be in this section 804?')
                  }
                } else if(results.status === 404 || error.status === 404) {} else {
                  if(error){console.log(JSON.stringify(error.data));}
                  return this.error_popup('Error: please contact admin');
                } 
              }))
            }

            if(this.active_user.permissions.includes('survey_questions:read')) {
              array_of_promises.push(
                axios.get('https://'+this.use_this_api_domain+'/survey_questions/question', { 
                params: {
                  org_id: this.active_org.org_id,
                  limit_results: this.default_limit || 25
                },
                headers: {
                      'Authorization': 'Bearer ' + this.active_user_jwt
                    }
                }).then((results,error) => {
                  if(results && results.status === 200 ) {
                    if(results.data && results.data.length && results.data.length >0) {
                      this.survey_questions = results.data

                    //  console.log('debug timing 857')
                    } else {
                      console.log('debug survey_questions is empty')
                    }
                  }
                  if(error) {
                    console.log(JSON.stringify(error))
                  }
                })
              )
            }

            if(this.active_user.permissions.includes('quick_replies:read')) {
              array_of_promises.push(
                axios.get('https://'+this.use_this_api_domain+'/quick_reply', { 
                  params: {
                    org_id: this.active_org.org_id,
                    this_user_uuid: this.active_user.user_uuid,
                    limit_results: this.default_limit || 25
                  },
                  headers: {
                      'Authorization': 'Bearer ' + this.active_user_jwt
                    }
                }).then((results,error) => {
                  if(results && results.status === 200 ) {
                    if(results.data && results.data.length && results.data.length >0) {
                      this.quick_replies = results.data
                    } else {
                      console.log('debug quick_replies is empty')
                    }
                  }
                  if(error) {
                    console.log(JSON.stringify(error))
                  }
                })
              )
            }

            if(this.active_user.permissions.includes('contacts:read')) {
              array_of_promises.push(
                axios.get('https://'+this.use_this_api_domain+'/contact/list', { 
                params: {
                  org_id: this.active_org.org_id,
                  script_type:'SMS',
                  limit_results: this.default_limit || 25
                },
                headers: {
                      'Authorization': 'Bearer ' + this.active_user_jwt
                    }
                }).then((results,error) => {
                  if(results && results.status === 200) {
                  // console.log('debug timing 876')
                    if(results.data && results.data.length && results.data.length > 0) {
                      this.contact_lists = results.data

                      this.get_list_stats()
                      
                    } else {
                      console.log('debug 824 should be here?')
                    }
                    
                  } else if(results.status === 404 || error.response.status === 404) {} else {
                    if(error){console.log(JSON.stringify(error.data));}
                    return this.error_popup('Error: please contact admin');
                  } 
                })
              )
            }

            if(this.active_user.permissions.includes('messages:send')) {
              array_of_promises.push(axios.get('https://'+this.use_this_api_domain+'/twilio/message_service', { 
                params: {
                  org_id: this.active_org.org_id,
                  is_active: true,
                  limit_results: this.default_limit || 25
                },
                headers: {
                    'Authorization': 'Bearer ' + this.active_user_jwt
                }
              })
              .then((results,error) => {

                if(results && results.status === 200) {
                //  console.log('debug timing 900')
                  if(results.data && results.data.length && results.data.length > 0) {
                      this.message_services = results.data

                      //also fill the arrays for use elsewhere
                      //let this_array_of_numbers = []

                      let this_array_of_number_messenger_services = []

                      if(results.data.length > 0 ) {
                        results.data.forEach(function(this_message_service,index) {
                          this_message_service.numbers.forEach(individual_number => {

                            this_array_of_number_messenger_services.push({
                              messaging_service_sid: results.data[index].messaging_service_sid,
                              phone_number: individual_number
                            })
                          // this_array_of_numbers.push(individual_number)

                          })

                        });

                        ///remove dupes
                        //this.array_of_numbers = [...new Set(this_array_of_numbers)];
                        //object for relationships
                        this.array_of_number_messenger_services = this_array_of_number_messenger_services

                        //this.set_active_messenger_service(null)

                      }
                    
                  } else {
                    console.log('debug shjouldnt be here? 859')
                  }
                } else if(results.status === 404 || results.status === 200) {
                // console.log('debug 821 message_services: ')
                // console.log(JSON.stringify(results))
                } else {
                  if(error){console.log(JSON.stringify(error.data));}
                  return this.error_popup('Error: please contact admin');
                } 
              }))
            }

          } else {
            return this.error_popup('login status error contact admin')
          }

          if(!array_of_promises || !array_of_promises.length || array_of_promises.length < 1) {
            console.log('array_of_promises')
            console.log(JSON.stringify(array_of_promises))
            return this.error_popup('you dont have permissions? contact admin')
          }

          //then get the rest of the data
          Promise.allSettled(array_of_promises)
          .then(results => {

            //TODO un dupe this
            this.init_data_loaded = true
            this.loading_init_data = false;

          })
          .catch(err=> {
            console.log(err.status)
            console.log(err.data)
            this.init_data_loaded = true
            this.loading_init_data = false;

            //show error
            this.error_popup('Error loading data. Refresh page or email support.')

          })

        } catch(e) {
          console.log(e)
          return this.error_popup('Error mounting user and org')
        }

        
      },
      is_object_empty: function(the_object) {
       // console.log('debug is_object_empty')
       // console.log(the_object)
        if(typeof the_object === 'undefined') {
          return true
        } 
        else if(JSON.stringify(the_object) === '{}') {
      //    console.log('debug 1205 stringify json hack')
          return true
        }
        else if(the_object // 👈 null and undefined check
          && Object.keys(the_object).length === 0
          && Object.getPrototypeOf(the_object) === Object.prototype )
        {
        //  console.log('debug 1212 the_object front object should have content')
          return false 
        } else {
       //   console.log('debug 1215 front the_object else ')
          return true
        }
      },
      current_timestamp: function() {
        return new Date().getTime()
      },
      change_tab: function(tab_name) {
        let current_active_tab_name = this.active_tab_name
        this.active_tab_name = tab_name
       // console.log(tab_name+"_name_button")

        try {
          document.getElementById(current_active_tab_name+"_nav_button").classList.remove('active_nav_button_color')
        } catch(e) {}
        

        //if is a sub menu for contacts drop down
        if(tab_name === 'lists' || tab_name === 'upload_contacts') {
          try {
            document.getElementById("people_nav_button").classList.add('active_nav_button_color')
          } catch(e) {}
          
        } else { 
          try {
            
            document.getElementById(tab_name+"_nav_button").classList.add('active_nav_button_color')
          } catch(e) {}
          
        }

        

      },
      remove_contacts_by_list_uuid: function(list_uuid) {
        //console.log('debug remove contacts by this list_uuid ' + list_uuid)
        try {
          this.contacts.forEach((contact,index) => {
            if(contact) {
              if(contact.lists.includes(list_uuid)) {
               // console.log('debug this contact contains this list_uuid')

              } else {
                //console.log('this contact does not have this list_uuid remove it ' + index + ' contact_uuid ' + contact.contact_uuid)
                this.contacts = this.contacts.splice(0, index)
              }
            }
          });
        } catch(e) {
          console.log(e)
        }
      },



      grab_new_contacts_async: async function(limit_number,new_list_uuid,select_sample_type) {

        var async_me = new Promise(function(resolve,reject) {

          if(typeof this.is_fetching_new_contacts !== 'undefined' && this.is_fetching_new_contacts !== true) {
            this.is_fetching_new_contacts = true
            
              /*
              if(this.is_fetching_new_contacts === true) {
                console.log('debug 1152 already pulling new contacts')
                setTimeout(() => {
                  this.is_fetching_new_contacts = false
                }, 5000);
                return
              } else {
                this.is_fetching_new_contacts = true
              }
              */
            
            let this_limit_number = 10
            if(!limit_number || limit_number === null || limit_number === 0 || Number.isInteger(limit_number) === false ) {

            } else {
              if(this.max_request_queue_contacts_number && limit_number <= this.max_request_queue_contacts_number) {
                  this_limit_number = limit_number
              }
            }
              
            if(!new_list_uuid || new_list_uuid === null) {
              console.log('no list_uuid passed into grab_new_contacts')
              //return
              this.is_fetching_new_contacts = false
              return null
            }

            if(!this.active_campaign || !this.active_campaign.outbound_campaign_uuid || this.active_campaign.outbound_campaign_uuid === null) {
              console.log('do not fetch there is no active campaign')
              this.is_fetching_new_contacts = false
              return 
            }

            // console.log('debug new_list_uuid ' + new_list_uuid)
              
              this.remove_contacts_by_list_uuid(new_list_uuid)

              //let return_contacts = false
              let the_result = null

              if(!select_sample_type || select_sample_type === null) {
                select_sample_type = 'ordered_limit'
              }

              let the_params = {
                org_id: this.active_org.org_id,
                list_uuid: new_list_uuid,
                only_unsent_contacts: true,
                outbound_campaign_uuid: this.active_campaign.outbound_campaign_uuid,
                has_sent_to:true,
                twilio_verified_cell:true,
                limit_results: this_limit_number,
                select_sample_type: select_sample_type || 'ordered_limit' //'ordered_limit' 'bernoulli' 'table_sample'
              }
              
              axios.get('https://'+this.use_this_api_domain+'/contact/queue_contacts', {
                params: the_params,
                headers: {
                    'Authorization': 'Bearer ' + this.active_user_jwt
                }

              })
              .then((results,error) => {
                
                if(results) {
                  //console.log(JSON.stringify(results))
                  //reset the retry loop
                  //console.log('1521 results')
                  console.log('debug this many new contacts')
                  console.log(results.data.length)
                  if(results.status !== 404) {
                    this.queue_contacts_track_requests = 0
                  }
                  
                }
                if(error ) {
                  console.log('debug has error in wrong place?')
                  console.log(error)
                  this.active_contact = helpers.empty_active_contact()
                  this.is_fetching_new_contacts = false 
                  return null
                }

                //shouldnt be necesary but let's stop any flickering bugs
                let should_set_new_active_contact = false
                if(this.contacts && this.contacts.length && this.contacts.length > 0) {
                  console.log('already has contacts length ' + this.contacts.length)
                } else {
                  console.log('no contacts length add new')
                  should_set_new_active_contact = true
                }

                console.log('debug new contacts 2234')


                //220125 add more checks for dupes
                //220829 debug
                //220308
                if (this.contacts && this.contacts.length && this.contacts.length === 0) {
                  console.log('debug no contacts loaded yet')
                  this.contacts = results.data
                  should_set_new_active_contact = true
                } else {
                  results.data.forEach(this_contact => {
                    //console.log(this_contact)
                    //let exit_sub_loop = false
                    //double check is not in contacts already
                    //there are so many edge cases for dupes.. take this n^ processing hit
                    if(this.contacts && this.contacts.length && this.contacts.length > 0) {

                      this.contacts.forEach(exiting_contact => {

                        if(exiting_contact && exiting_contact.contact_uuid && exiting_contact.contact_uuid === this_contact.contact_uuid) {
                          console.log('debug this contact is already in contacts? dont append')
                        //} else if(exit_sub_loop === false) {
                        } else {
                          console.log('contact not in contacts push it')
                          this.contacts.push(this_contact)
                          //exit_sub_loop = true
                        }
                      });
                    } 
                    //220308
                    //else {
                    //  this.contacts.push(this_contact)
                    //}
                
                  });
                }
                
                
                if(should_set_new_active_contact === true) {
                  console.log('setting this active_contact')
                  console.log(JSON.stringify(this.contacts[0]))
                  this.active_contact = this.contacts[0]
                }
              
                //is this needed?

                this.generate_active_message()
                
                the_result = results || null
                this.is_fetching_new_contacts = false
                //return null or the results it's async so maybe we need to use the contacts somewhere sometime
                return the_result
              //  console.log('debug 1228')
              })
              .catch((error) => {
                this.is_fetching_new_contacts = false
                if(error) {
                  if(error.response.status === 404) {

                    //request contacts again in smaller amount because we are adding back randomness and it uses the imit as the sample. so if there are 10 unsent contacts but this limit is 5 it will not pull any
                    //do it twice?
                    this.queue_contacts_track_requests = this.queue_contacts_track_requests + 1

                    if( this.queue_contacts_track_requests <= 1  ) {
                      if(new_list_uuid && new_list_uuid !== null) {
                        
                        //only if the last limit number is 5 or more
                        if(this_limit_number && this_limit_number >= 5 ) {
                          //divide by 2
                          this.grab_new_contacts(Math.round(this_limit_number / 2),new_list_uuid,'ordered_limit')
                        } else {
                          this.queue_contacts_track_requests = 0
                        }
                      } 
                    
                    } else {
                      //reset 
                      this.queue_contacts_track_requests = 0
                    }

                  } else {
                    console.log(error)
                    console.log('debug major error throw one')
                    this.active_contact = helpers.empty_active_contact()
                    this.error_popup('Error grabing new contacts')
                  }
                }
              
                return null
              })
          }
        })

        async_me()

       
      },
      refresh_contact_list_stats: function(this_list_uuid,attempts,backoff_time) {
        if(typeof attempts === 'undefined' || attempts === null ) {
          console.log('need to pass attempts so refresh_contact_list_stats wont inifnite loop')
          return
        }
        if(!backoff_time) {
          backoff_time =  5000
        }

        if(!this_list_uuid) {
          console.log('debug no list_uuid passed?')
          return
        }

        if(attempts < 4) {
          
          this.get_list_stats(this_list_uuid)

          backoff_time = backoff_time * 10 // 0:5000 1:50000 2: 500000 (8 min)  3: would be 83 minute..
          if(backoff_time > 600000) {
            backoff_time = 600000 //10 mins
          }
          attempts = attempts+1
          setTimeout(() => {
            this.refresh_contact_list_stats(this_list_uuid,attempts,backoff_time)
          }, backoff_time);
          
        }
      },
      grab_new_contacts: function(limit_number,new_list_uuid,select_sample_type) {

        if(typeof this.is_fetching_new_contacts !== 'undefined' && this.is_fetching_new_contacts !== true) {
          this.is_fetching_new_contacts = true
          
            /*
            if(this.is_fetching_new_contacts === true) {
              console.log('debug 1152 already pulling new contacts')
              setTimeout(() => {
                this.is_fetching_new_contacts = false
              }, 5000);
              return
            } else {
              this.is_fetching_new_contacts = true
            }
            */
          
          let this_limit_number = 10
          if(!limit_number || limit_number === null || limit_number === 0 || Number.isInteger(limit_number) === false ) {

          } else {
            if(this.max_request_queue_contacts_number && limit_number <= this.max_request_queue_contacts_number) {
                this_limit_number = limit_number
            }
          }
            
          if(!new_list_uuid || new_list_uuid === null) {
            console.log('no list_uuid passed into grab_new_contacts')
            //return
            this.is_fetching_new_contacts = false
            return null
          }

          if(!this.active_campaign || !this.active_campaign.outbound_campaign_uuid || this.active_campaign.outbound_campaign_uuid === null) {
            console.log('do not fetch there is no active campaign')
            this.is_fetching_new_contacts = false
            return 
          }

          // console.log('debug new_list_uuid ' + new_list_uuid)
            
            this.remove_contacts_by_list_uuid(new_list_uuid)

            //let return_contacts = false
            let the_result = null

            if(!select_sample_type || select_sample_type === null) {
              select_sample_type = 'ordered_limit'
            }

            let the_params = {
              org_id: this.active_org.org_id,
              list_uuid: new_list_uuid,
              only_unsent_contacts: true,
              outbound_campaign_uuid: this.active_campaign.outbound_campaign_uuid,
              has_sent_to:true,
              twilio_verified_cell:true,
              limit_results: this_limit_number,
              select_sample_type: select_sample_type || 'ordered_limit' //'ordered_limit' 'bernoulli' 'table_sample'
            }
            
            axios.get('https://'+this.use_this_api_domain+'/contact/queue_contacts', {
              params: the_params,
              headers: {
                  'Authorization': 'Bearer ' + this.active_user_jwt
              }
            })
            .then((results,error) => {
              
              if(results) {
                //console.log(JSON.stringify(results))
                //reset the retry loop
                console.log('debug 2433 new contacts results')
                console.log(results.data.length)
                if(results.status !== 404) {
                  this.queue_contacts_track_requests = 0
                }
                
              }
              if(error ) {
                console.log('debug has error in wrong place?')
                console.log(error)
                this.active_contact = helpers.empty_active_contact()
                this.is_fetching_new_contacts = false 
                return null
              }

              //shouldnt be necesary but let's stop any flickering bugs
              let should_set_new_active_contact = false
              if(this.contacts && this.contacts.length && this.contacts.length > 0) {
                console.log('already has contacts length ' + this.contacts.length)
              } else {
                should_set_new_active_contact = true
              }

              if(this.contacts && this.contacts.length && this.contacts.length === 0) {
                //220125 add more checks for dupes
                //220829 debug
                //230308
                results.data.forEach(this_contact => {
                  //console.log(this_contact)
                  //let exit_sub_loop = false
                  //double check is not in contacts already
                  //there are so many edge cases for dupes.. take this n^ processing hit
                  if(this.contacts && this.contacts.length && this.contacts.length > 0) {
                    this.contacts.forEach(exiting_contact => {
                      if(exiting_contact && exiting_contact.contact_uuid && exiting_contact.contact_uuid === this_contact.contact_uuid) {
                        console.log('debug this contact is already in contacts? dont append')
                      //} else if(exit_sub_loop === false) {
                      } else {
                        //console.log('push this contact')
                        this.contacts.push(this_contact)
                        //exit_sub_loop = true
                      }
                    });
                  } else {
                    this.contacts.push(this_contact)
                  }
              
                });
              } else {
                should_set_new_active_contact = true
                this.contacts = results.data
              }

              
              
              if(should_set_new_active_contact === true) {
                //console.log(JSON.stringify(this.contacts[0]))

                this.active_contact = this.contacts[0]
              
              }
            
              //is this needed?

              this.generate_active_message()
              
              the_result = results || null
              this.is_fetching_new_contacts = false
              //return null or the results it's async so maybe we need to use the contacts somewhere sometime
              return the_result
            //  console.log('debug 1228')
            })
            .catch((error) => {
              this.is_fetching_new_contacts = false
              if(error) {
                if(error.response.status === 404) {

                  //request contacts again in smaller amount because we are adding back randomness and it uses the imit as the sample. so if there are 10 unsent contacts but this limit is 5 it will not pull any
                  //do it twice?
                  this.queue_contacts_track_requests = this.queue_contacts_track_requests + 1

                  if( this.queue_contacts_track_requests <= 1  ) {
                    if(new_list_uuid && new_list_uuid !== null) {
                      
                      //only if the last limit number is 5 or more
                      if(this_limit_number && this_limit_number >= 5 ) {
                        //divide by 2
                        this.grab_new_contacts(Math.round(this_limit_number / 2),new_list_uuid,'ordered_limit')
                      } else {
                        this.queue_contacts_track_requests = 0
                      }
                    } 
                  
                  } else {
                    //reset 
                    this.queue_contacts_track_requests = 0
                  }

                } else {
                  console.log(error)
                  console.log('debug major error throw one')
                  this.active_contact = helpers.empty_active_contact()
                  this.error_popup('Error grabing new contacts')
                }
              }
            
              return null
            })
        }

       
      },
     
      generate_active_message: function() {

        let this_active_message = {
          "org_id":this.active_org.org_id,
          "user_uuid_created":this.active_user.user_uuid,
          "outbound_campaign_uuid": null,
          "list_uuid":null,
          "script_uuid":null,
          "outbound_campaign_type":"SMS",
          "contact_uuid":null,
          "account_sid":null,
          "messaging_service_sid":null,
          "from":null,
          "sent_to":null,
          "body":this.rendered_message_body || null,
          "sms_attachment":this.rendered_message_sms_attachment || null
        }

        if(this.active_campaign && this.active_campaign.outbound_campaign_uuid) {
          this_active_message.outbound_campaign_uuid = this.active_campaign.outbound_campaign_uuid
        }

        if(this.active_list && this.active_list.list_uuid) {
          this_active_message.list_uuid = this.active_list.list_uuid
        }

        if(this.active_script && this.active_script.script_uuid) {
          this_active_message.script_uuid = this.active_script.script_uuid
        }



        if(this.active_contact) {
          if(this.active_contact.contact_uuid) {
            this_active_message.contact_uuid = this.active_contact.contact_uuid
          }
          if(this.active_contact.sent_to) {
            this_active_message.sent_to = this.active_contact.sent_to
          }
        }

        if(this.active_messenger_service) {
          if(this.active_messenger_service.account_sid) {
            this_active_message.account_sid = this.active_messenger_service.account_sid
          }
          if(this.active_messenger_service.messaging_service_sid) {
            this_active_message.messaging_service_sid = this.active_messenger_service.messaging_service_sid
          }
        }

         if(this.active_campaign && this.active_campaign.phone_number) {
          this_active_message.phone_number = this.active_campaign.phone_number
        }



        this.active_message = this_active_message
      },
      return_empty_active_contact: function() {

        return {
          org_id: null,
          contact_uuid: null,
          address: null,
          cell_phone: null,
          city: null,
          last_queued_timestamp: null,
          date_created:null,
          do_not_call: null,
          email: null,
          external_contact_uuid: null,
          external_contact_uuid_source: null,
          first_name:null,
          gender:null,
          is_sms_optout:true,
          json_contact_data: null,//base64 json string
          last_modified:null,
          last_name: null,
          list_type:null,
          lists: [],
          primary_phone:null,
          sent:null,
          sent_to:null,
          state: null,
          twilio_verified_cell:null,
          user_uuid_created: null,
          user_uuid_last_modified:null,
          van_id:null,
          verified_cell_phone: null,
          zip:null
        }
        
      },
      get_list_stats: function(single_list_uuid) {
       
        try {

          let this_body_format = {
              "org_id": this.active_user.org_id,
              "table_name":"contact_lists_data",
              //"group_by":["list_uuid"],
              "aggregate_group_by":{
                  "lists":{"type":"array","as":"list_uuid"}
              },
              "aggregate_select_fields": {
                  "count_all": {"type":"count_all"},
                  "sent_to": {"type":"count_distinct"},
                  "twilio_verified_cell": {"type":"sum","child_type":"case_when_true"},
                  "is_sms_optout": {"type":"sum","child_type":"case_when_true"}
              },
              "where": {
                  or: []
              },
              "order_by":[{"date_created":"desc"}],
              limit: this.contact_lists.length || 50
          }

          if(typeof single_list_uuid === 'undefined' || single_list_uuid === null) {
            let array_of_list_uuid_objects = []

            this.contact_lists.forEach(single_list => {
              array_of_list_uuid_objects.push({column_name:'lists',type:'array',value:single_list.list_uuid,child_type:'string'})
            });

            this_body_format.where.or = array_of_list_uuid_objects

          } else {
            this_body_format.where.or = [{column_name:'lists',type:'array',value:single_list_uuid,child_type:'string'}]
          }
          
          axios.post('https://'+this.use_this_api_domain+'/stats/contact_lists', this_body_format, {
            headers: {
                'Authorization': 'Bearer ' + this.active_user_jwt
            }
          })
          .then((results,error) => {
            if(results) {
              if(results.status === 200) {

                //has some odd values...
                let new_good_results = []
                try {
                  results.data.forEach(single_result => {
                    if(single_result.list_uuid && single_result.list_uuid !== null && single_result.list_uuid !== '' && single_result.list_uuid !== 'error') {
                    new_good_results.push(single_result)
                    }
                  });
                } catch(e) {
                  console.log(e)
                }

                this.contact_lists_stats = helpers.merge_array_of_objects(this.contact_lists_stats,new_good_results,'list_uuid') //(original, newdata, selector = 'key') 

              }
            }
          })
          .catch((error) => {
            
          })


        } catch(e) {
          console.log(e)
        }
        
      },
      get_survey_question_response: function(get_params,callback_function) {
        //contact_uuid,sent_to,script_uuid,survey_question_uuid,survey_question_answer_value,survey_question_data_type,user_uuid_created,limit
        //date_created:
        // last_modified:
        // date_created_before:
        // last_modified_before: 
        // date_created_after: 
        // last_modified_after

        if(typeof callback_function === 'undefined' || callback_function === null) {
          console.log('debug no callback_function')
          var callback_function = () => {
            return null
          }
        }

        try {

          axios.get('https://'+this.use_this_api_domain+'/stats/survey_questions/answers', {
            params: get_params,
            headers: {
                'Authorization': 'Bearer ' + this.active_user_jwt
            }
          })
          .then((results,error) => {
         
            if(results) {

              if(results.status === 200) {
                return callback_function(results.data)
              } else {
                console.log('debug shouldnt be here? error get sc answers has results but not status 200')
                console.log(results)
                return callback_function(null)
              }
            } else {
              console.log('debug shuoldnt be here no results or error get sc results')
              return callback_function(null)
            }
          })
          .catch((error) => {
            if(error.status && error.status !== 404) {
              console.log('debug 2462 error grabing survey question responses')
              console.log(error)
            }
            return callback_function(null)
          })


        } catch(e) {
          console.log(e)
          return callback_function(null)
        }
        
      },
      cascade_updates_on_new_active_campaign: function(set_this_active_list,set_this_active_script,recursive_loop_count,recursive_time,set_this_active_campaign_uuid) {
        //console.log('debug start cascade')
        //console.log(set_this_active_list || null)
        //console.log(set_this_active_script || null)
        //console.log(set_this_active_campaign_uuid || null)

        if(!recursive_loop_count) {
          recursive_loop_count = 0
        }
        if(!recursive_time) {
          recursive_time = 500
        }

        if(recursive_loop_count > 5) {
          return this.error_popup('Error loading data. Try to refresh your login or contact admin.') 
        }
        if(this.loading_init_data === false) {
          //console.log('new campaign_uuid set start cascade_updates_on_new_active_campaign')


          //let's add a check so there is no accidental loop
          if(set_this_active_campaign_uuid && set_this_active_campaign_uuid !== null) {
            if(this.active_outbound_campaign_uuid && this.active_outbound_campaign_uuid !== null ) {
              //is this.active_outbound_campaign_uuid match set_this_active_campaign_uuid
              if(set_this_active_campaign_uuid === this.active_outbound_campaign_uuid) {
                //active_campaign uuid too
                if(this.active_campaign && this.active_campaign.outbound_campaign_uuid && this.active_campaign.outbound_campaign_uuid === set_this_active_campaign_uuid) {
                  //active script
                  if(this.active_script && this.active_script.script_uuid && set_this_active_script && this.active_script.script_uuid === set_this_active_script) {
                    if(this.active_list && this.active_list.list_uuid && set_this_active_list && set_this_active_list === this.active_list.list_uuid) {
                      console.log('on cascade everything is already set active just return')
                      return
                    }
                  }
                }
              }
            }
          }
          

          //set the active_campaign by looping through active_outbound_campaign_uuid campaigns
          //IF there is an active_outbound_campaign_uuid
          //if(this.active_outbound_campaign_uuid && this.active_outbound_campaign_uuid !== null) {

            //already matches the passed set_this_active_campaign_uuid
            //if(set_this_active_campaign_uuid && set_this_active_campaign_uuid !== null && this.active_outbound_campaign_uuid === set_this_active_campaign_uuid) {
              
              //search for this set_this_active_campaign_uuid

              if(!set_this_active_campaign_uuid || set_this_active_campaign_uuid === null) {
                console.log('no set_this_active_campaign_uuid passed')
                //return
              } else {
                let found_a_campaign_uuid_match = false
                for (let i = 0; i < this.outbound_campaigns.length; i++) {
                  //console.log(this.outbound_campaigns[i].outbound_campaign_uuid)
                  if(this.outbound_campaigns[i].outbound_campaign_uuid === set_this_active_campaign_uuid) {
                    if(found_a_campaign_uuid_match !== true) {
                      //check for only once
                      this.active_campaign = this.outbound_campaigns[i]
                      this.active_outbound_campaign_uuid = set_this_active_campaign_uuid
                      found_a_campaign_uuid_match = true
                    }
                    
                  }
                }
                if(found_a_campaign_uuid_match === false) {
                  //TODO grab new campaign by uuid
                  return this.get_missing_outbound_campaign(set_this_active_campaign_uuid)
                  //return this.error_popup('No campaign_uuid found in campaigns for the value passed?')
                }
              }

            

            
          //}

          //set active_list now contains logic to get any missing.
          //if list_uuid is in active_campaign set the first as active
          if(this.active_campaign.list_uuids && this.active_campaign.list_uuids.length && this.active_campaign.list_uuids.length > 0) {
            if(set_this_active_list && set_this_active_list !== null) {
              this.set_active_list(set_this_active_list)
            } else {
              set_this_active_list = this.active_campaign.list_uuids[0]
              this.set_active_list(this.active_campaign.list_uuids[0])
            }
            
          }

          if(this.active_campaign.scripts && this.active_campaign.scripts.length && this.active_campaign.scripts.length > 0) {
            if(set_this_active_script && set_this_active_script !== null) {
              this.set_active_script(set_this_active_script)
            } else {
              set_this_active_script = this.active_campaign.scripts[0]
              this.set_active_script(this.active_campaign.scripts[0])
            }
            
          }

          //console.log('debug cascase on new active campaign set this messaging_service_sid service sid '  + this.active_campaign.messaging_service_sid)
          //console.log('cascade set new active messenger service')
          this.set_active_messenger_service(this.active_campaign.messaging_service_sid) // sets this.active_messenger_service

          //todo need to add a survey question lookup check?

          //what about setting active_outbound_campaign_uuid will it just cause an infinite loop?


        } else {
          //console.log('cascade but init data not loaded. set timeout? ')
          recursive_time = recursive_time * 2
          recursive_loop_count = recursive_loop_count + 1
          setTimeout(() => {
            this.cascade_updates_on_new_active_campaign(set_this_active_list,set_this_active_script,recursive_loop_count,recursive_time,set_this_active_campaign_uuid)
          }, recursive_time || 1000);
        }
        
      },
      get_outbound_campaign_stats_callback: function(passed_outbound_campaign_uuid,group_by,limit,callback_function) {

        if(typeof callback_function === 'undefined' || typeof this.active_org.org_id === 'undefined') {
          console.log('no callback function 2258 get stats maybe timing issue?')
          return null
        }

        if(typeof this.active_user.permissions === 'undefined' || !this.active_user.permissions.includes('campaigns:read') && !this.active_user.permissions.includes('campaigns:create')) {
          return error_popup('do not have permissions to get campaigns?')
        }

        let this_stats_request_body = {
          "org_id": this.active_org.org_id,
          "table_name": "outbound_message",
          "aggregate_select_fields": {
              "count_all": {
                  "type": "count_all"
              },
              "sent_to": {
                  "type": "count_distinct"
              },
              "status": {
                  "type": "sum",
                  "child_type": "case_when_multi",
                  "multi_case_when_values": [
                      "accepted",
                      "error"
                  ]
              }
          },
          "where": {}
        }

        if(typeof group_by !== 'undefined' && Array.isArray(group_by) && group_by.length > 0) {
          this_stats_request_body.group_by = group_by
        }

        if(typeof limit !== 'undefined' && limit > 0) {
          this_stats_request_body.limit = limit
        } else {
          //just do 30 ?
          this_stats_request_body.limit = 50
        }

        if(typeof passed_outbound_campaign_uuid !== 'undefined' && passed_outbound_campaign_uuid !== null) {
          this_stats_request_body.where = {"outbound_campaign_uuid": {"type":"string","value":passed_outbound_campaign_uuid}}
        } else {
          //should request the ones in the array only i think like the lists stats
          let this_or_array = []
        
          if(typeof this.outbound_campaigns !== 'undefined' && this.outbound_campaigns.length && this.outbound_campaigns.length > 0) {

            this.outbound_campaigns.forEach(single_outbound_campaign => {
              this_or_array.push(
                {
                  column_name:'outbound_campaign_uuid',
                  type:'string',
                  value: single_outbound_campaign.outbound_campaign_uuid
                }
              )
            });

            if(this_or_array.length > 0) {

              this_stats_request_body.where = {
                or: this_or_array
              }

              //limit should be equal
              this_stats_request_body.limit = this_or_array.length

              //TODO some kind of paging? e.g. if the campaign array has more than 50 items should call this twice
            } else {
              console.log('found no campaigns for where? 2218 campaign stats')
            }
            
          }

        }

        axios.post('https://'+this.use_this_api_domain+'/stats/outbound_campaigns', this_stats_request_body, {
          headers: {
              'Authorization': 'Bearer ' + this.active_user_jwt
          }
        })
        .then((results,error) => {
          if(results) {
            if(results.status === 200) {
              return callback_function(results.data)
            } else {
              console.log('debu 2189 get campaign stats response not good?')
              return callback_function(null)
            }
          }
          else if(error) {
            console.log('campaign stats error')
            console.log(error || null)
            return callback_function(null)
          } else {
            console.log('campagin stats shouldnt be here 2250')
            return callback_function(null)
          }
        })
        .catch((error) => {
          console.log('get campaign stats error')
          console.log(JSON.stringify(this_stats_request_body))
          console.log(error)
          return callback_function(null)
        })

      },
      get_generic_stats: function(date_created_before,date_created_after) {
        try {

          if(typeof date_created_before === 'undefined' || date_created_before === null) {
            date_created_before = moment().endOf('month').unix()
          }

          if(typeof date_created_after === 'undefined' || date_created_after === null) {
            date_created_after = moment().startOf('month').unix()
          }
       
          let callback_function_get_messages_sent = (results) => {
            this.fetching_stats_status.outbound_messages = false
            //console.log('got the first stats of all messages this month by messenger service sid')
            //  console.log(JSON.stringify(results))

            if(results && results.length && results.length > 0) {
              let count_all_accepted = 0
              let count_all_error = 0
              let count_sent_to = 0
              results.forEach(single_messenger_service_stat => {
                count_all_accepted = count_all_accepted+single_messenger_service_stat.status_accepted
                count_all_error = count_all_error + single_messenger_service_stat.status_error
                count_sent_to = count_sent_to + single_messenger_service_stat.sent_to
              });

              this.stats.messages_this_month.count_all_accepted = count_all_accepted
              this.stats.messages_this_month.count_all_error = count_all_error
              this.stats.messages_this_month.count_sent_to = count_sent_to

            } else {
              this.stats.messages_this_month.count_all_accepted = 0
              this.stats.messages_this_month.count_all_error = 0
              this.stats.messages_this_month.count_sent_to = 0
            }
          }

          this.get_stats_messages_sent(date_created_after,date_created_before,null,null,['messaging_service_sid'],callback_function_get_messages_sent)

          //get this survey questions] uuids survey question responses
          //just get them for the month
          let process_survey_question_stats = (results) => {
            this.fetching_stats_status.survey_questions = false
            
            //these results are triple grouped by survey question -> script -> response answer i think
            if(results && results != null && results.length && results.length > 0) {
              this.stats.survey_question_answers = results
            } else {
              this.stats.survey_question_answers = []
            }
            
          }

          this.stats_survey_question_responses(date_created_after,date_created_before,null,null,["survey_question_uuid","script_uuid","survey_question_answer_value"],null,null,process_survey_question_stats)
          
        } catch(e) {
          console.log(e)
        }
      },
      stats_survey_question_responses: function(date_created_after,date_created_before,survey_question_uuids,script_uuid,group_by,survey_question_answer_value,survey_question_data_type,callback_function) {

        this.fetching_stats_status.survey_questions = true

        var the_request = {
            "org_id": this.active_org.org_id,
            "table_name": "survey_question_answers",
            "group_by": [
                
            ],
            "aggregate_select_fields": {
                "count_all": {
                    "type": "count_all"
                }
            },
            "where": {or:null},
            "order_by": [
                {
                    "date_created": "desc"
                }
            ],
            "limit": 50
        }


        if(typeof group_by !== 'undefined' && Array.isArray(group_by) && group_by.length > 0 ) {
          the_request.group_by = group_by
          //"survey_question_uuid","script_uuid","survey_question_answer_value", 'survey_question_answer_value','survey_question_data_type'
        }

        if(typeof survey_question_uuids !== 'undefined' && survey_question_uuids !== null && Array.isArray(survey_question_uuids) && survey_question_uuids.length > 0) {
          let this_or_array = []

          survey_question_uuids.forEach(survey_question_uuid => {
            this_or_array.push(
              {
                column_name:'survey_question_uuid',
                type:'string',
                value: survey_question_uuid
              }
            )
          });

          if(this_or_array.length > 0) {

            the_request.where.or = this_or_array

          }
          
        }

        if(typeof date_created_before !== 'undefined' && date_created_before !== null) {
          the_request.where.date_created_before = {type:'timestamp',value: date_created_before,timestamp_compare:'before'}
        }

        if(typeof date_created_after !== 'undefined' && date_created_after !== null) {
          the_request.where.date_created_after = {type:'timestamp',value: date_created_after,timestamp_compare:'after'}
        }

        if(typeof script_uuid !== 'undefined' && script_uuid !== null) {
          the_request.where.script_uuid = {type:'string',value: script_uuid}
        }

        if(typeof survey_question_answer_value !== 'undefined' && survey_question_answer_value !== null) {
          the_request.where.survey_question_answer_value = {type:'string',value: survey_question_answer_value}
        }

        if(typeof survey_question_data_type !== 'undefined' && survey_question_data_type !== null) {
          the_request.where.survey_question_data_type = {type:'string',value: survey_question_data_type}
        }

        if(typeof the_request.where.or === 'undefined' || the_request.where.or === null) {
          delete the_request.where.or
        }

        if(typeof the_request.where === 'undefined' || the_request.where === null) {
          delete the_request.where
        }

        if(typeof the_request.group_by === 'undefined' || the_request.group_by === null || group_by.length === 0) {
          delete the_request.group_by
        }

        axios.post('https://'+this.use_this_api_domain+'/stats/survey_questions/answers', the_request, {
          headers: {
              'Authorization': 'Bearer ' + this.active_user_jwt
          }
        })
        .then((results,error) => {
          if(results) {
            if(results.status === 200) {
              return callback_function(results.data)
            } else {
              console.log('debu 2627')
              return callback_function(null)
            }
          }
          else if(error) {
            console.log('debug 2632')
            console.log(error || null)
            return callback_function(null)
          } else {
            console.log('debug 2636')
            return callback_function(null)
          }
        })
        .catch((error) => {
          if(typeof error.response.status !== 'undefined' && error.response.status === 404) {
            return callback_function(null)
          } else {
            console.log('debug 2641')
            console.log(JSON.stringify(the_request))
            console.log(error)
            return callback_function(null)
          }
          
        })

      },





      //TODO add all loaded campaugn uuids into the call function in case of super large orgs
      process_get_twilio_stats_all_time: function(results) {
        //console.log('process_get_twilio_stats_all_time')
        //console.log(results)
        if(typeof results === 'undefined' || results === null) {
          console.log('process_get_twilio_stats_all_time has no results?')
          return
        } else {
          this.stats.all_time_outbound_campaigns_complex_stats = results
          this.stats_backdoor ++
        }
        
      },
      process_get_twilio_logs_complex_stats_join_campaign: function(results) {

        if(results && results !== null) {

          //TODO is there a way to merge or update?
          let clone_existing = JSON.parse(JSON.stringify(this.stats.outbound_campaigns_complex_stats))
          

          //this will add survey question results sum into these
          for (var new_outbound_campaign_id in results) {
            if (results.hasOwnProperty(new_outbound_campaign_id)) {
              //might not be necesary i just want to make sure we save any old values e.g. call this for single campaign uuid
              if(typeof clone_existing[new_outbound_campaign_id] === 'undefined') {
                clone_existing[new_outbound_campaign_id] = results[new_outbound_campaign_id]
                
                clone_existing[new_outbound_campaign_id].survey_question_responses = 0
                try {
                  if(typeof results[new_outbound_campaign_id].script_uuid !== 'undefined' && results[new_outbound_campaign_id].script_uuid !== null) {
                    //TODO start here add a survey response number here?
                    //when has result from get survey question answers, create compute that loops through because it's grouped by answer value
                    //new computed
                    let transform_to_by_sc_id = {
                      some_sc_uuid: {
                        all_counts:'sum',
                        answers_count: {
                          '5':5,
                          '1':0
                        }
                      }
                    }
                    let transform_to_by_script_uuid = {
                      scrip_uuid:  {
                        all_counts:'sum',
                        answers_count: {
                          '5':5,
                          '1':0
                        }
                      }
                    }

                    //add summary column
                    //add seperate table to stats

                    clone_existing[new_outbound_campaign_id].survey_question_responses = 0
                  }
                } catch(e) {
                  console.log(e)
                }
                
              } else {
                clone_existing[new_outbound_campaign_id] = results[new_outbound_campaign_id]
                clone_existing[new_outbound_campaign_id].survey_question_responses = 0
              }

            }
          }

          this.stats.outbound_campaigns_complex_stats = clone_existing
        } else {
          this.stats.outbound_campaigns_complex_stats = {}
        }

        this.stats_backdoor++
        this.fetching_stats_status.complex_twilio_stats = false

      },
      get_twilio_logs_complex_stats_join_campaign: function(outbound_campaign_uuids,callback_function,date_created_before,date_created_after,set_loading_status) {

        
        this.stats.count_bounced_this_month = '⟳'

        if(typeof set_loading_status === 'undefined' || 
          ( typeof set_load_status !== 'undefined' && ( set_load_status === null || set_loading_status !== false || set_loading_status === true ) )
          
        ) {
          this.fetching_stats_status.complex_twilio_stats = true
        }

        this.stats.outbound_campaigns_complex_stats = {}

        if(typeof callback_function === 'undefined' || callback_function === null) {
          console.log('need to pass callback_function into get_twilio_logs_complex_stats_join_campaign')
          callback_function = this.process_get_twilio_logs_complex_stats_join_campaign
        } 

        let this_query = {
          org_id:this.active_org.org_id
        }

        if(typeof outbound_campaign_uuids !== 'undefined' && outbound_campaign_uuids !== null && outbound_campaign_uuids.length && outbound_campaign_uuids.length > 0) {
          this_query.outbound_campaign_uuids = outbound_campaign_uuids
        }

        if(typeof date_created_after !== 'undefined' && date_created_after !== null) {
          this_query.date_created_after = date_created_after
        }

        if(typeof date_created_before !== 'undefined' && date_created_before !== null ) {
          this_query.date_created_before = date_created_before
        }
        
        if(!this.active_user_jwt) {
          console.log('timing error no this.active_user_jwt?')
        }

        axios.post('https://'+this.use_this_api_domain+'/stats/twilio_logs/outbound_campaigns/scripts', this_query, {
          headers: {
              'Authorization': 'Bearer ' + this.active_user_jwt
          }
        })
        .then((results,error) => {
          if(results) {
            if(results.status === 200) {

              return callback_function(results.data)

            } else {
              console.log('get_twilio_logs_complex_stats_join_campaignstats error?')
              return callback_function(null)
            }
          } else{
            if(error) {
              console.log(error)
            }
            console.log('no results get_twilio_logs_complex_stats_join_campaign?')
            return callback_function(null)
          }
        })
        .catch((error) => {
          if(typeof error.response.status !== 'undefined' && error.response.status === 404) {
            return callback_function(null)
          } else {
            console.log(' get_twilio_logs_complex_stats_join_campaign stats error')
            console.log(error)
            return callback_function(null)
          }
          
        })

        
      },
      get_stats_messages_sent: function(time_after,time_before,passed_outbound_campaign_uuid,passed_messaging_service_sid,group_by,callback_function) {
        
        if(!this.active_user.permissions.includes('campaigns:read') && !this.active_user.permissions.includes('campaigns:create')) {
          console.log('do not have permissions for campaigns just dont get stats?')
          return
        }

        if(typeof callback_function === 'undefined') {
          console.log('missing callback_function 2255')
          return
        }

        this.fetching_stats_status.outbound_messages = true

        let these_messages_stats = {
          "org_id": this.active_org.org_id,
          "table_name": "outbound_message",
          "aggregate_select_fields": {
              "count_all": {
                  "type": "count_all"
              },
              "sent_to": {
                  "type": "count_distinct"
              },
              "status": {
                  "type": "sum",
                  "child_type": "case_when_multi",
                  "multi_case_when_values": [
                      "accepted",
                      "error"
                  ]
              }
          },
          group_by:[],
          "where": {}
        }

        if(typeof time_before !== 'undefined' && time_before !== null) {
          these_messages_stats.where.date_created_before = {type:'timestamp',value: time_before,timestamp_compare:'before'}
        }

        if(typeof time_after !== 'undefined' && time_after !== null) {
          these_messages_stats.where.date_created_after = {type:'timestamp',value: time_after,timestamp_compare:'after'}
        }

        if(typeof passed_messaging_service_sid !== 'undefined' && passed_messaging_service_sid !== null) {
          these_messages_stats.where.messaging_service_sid = {type:'string',value: passed_messaging_service_sid}
        }

        if(typeof passed_outbound_campaign_uuid !== 'undefined' && passed_outbound_campaign_uuid !== null) {
          these_messages_stats.where.outbound_campaign_uuid = {type:'string',value: passed_outbound_campaign_uuid}
        }

        if(typeof group_by !== 'undefined' && group_by !== null && group_by.length && group_by.length >0) {
          these_messages_stats.group_by = group_by
        } else {
          delete these_messages_stats.group_by
        }

        if(Object.keys(these_messages_stats.where).length === 0) {
          delete these_messages_stats.where
        }

        axios.post('https://'+this.use_this_api_domain+'/stats/outbound_messages', these_messages_stats, {
          headers: {
              'Authorization': 'Bearer ' + this.active_user_jwt
          }
        })
        .then((results,error) => {
          if(results) {
            if(results.status === 200) {

              return callback_function(results.data)

            } else {
              console.log('get outbound message stats error?')
              return callback_function(null)
            }
          } else{
            if(error) {console.log(error)}
            console.log('no results get outbound messages?')
            return callback_function(null)
          }
        })
        .catch((error) => {
          if(typeof error.response.status !== 'undefined' && error.response.status === 404) {
            return callback_function(null)
          } else {
            console.log('get lists stats error')
            console.log(JSON.stringify(error))
            console.log(error)
            return callback_function(null)
          }
        })

      },
      get_init_this_month_complex_stats: function() {
        if(typeof this.active_user_jwt === 'undefined' || this.active_user_jwt === null) {
          console.log('timing error why no jwt??')
          return setTimeout(() => {
            this.get_init_this_month_complex_stats()
          }, 1000);
        } else {
          let all_campaign_uuids = []

          this.outbound_campaigns.forEach(single_campaign => {
            if(typeof single_campaign.outbound_campaign_uuid !== 'undefined') {
              all_campaign_uuids.push(single_campaign.outbound_campaign_uuid)
            }
          })

          //All time for the campaigns table graphs
          this.get_twilio_logs_complex_stats_join_campaign(null,this.process_get_twilio_stats_all_time,null,null,false)

          //Only this month
          //220511 jsut get them all since these are stats idk if there would be a case where there were more than 30 campaigns sent in this month maybe
          this.get_twilio_logs_complex_stats_join_campaign(null,this.process_get_twilio_logs_complex_stats_join_campaign,moment().endOf('month').unix(),moment().startOf('month').unix())
          /*if(all_campaign_uuids.length && all_campaign_uuids.length > 0) {
            //get all the current campaign _uuids
            this.get_twilio_logs_complex_stats_join_campaign(all_campaign_uuids,this.process_get_twilio_logs_complex_stats_join_campaign,moment().endOf('month').unix(),moment().startOf('month').unix())

          } else {
            console.log('debug shuoldnt be here? no stats no campaigns')
            //this.get_twilio_logs_complex_stats_join_campaign(null,this.process_get_twilio_logs_complex_stats_join_campaign)
          }*/

          this.get_generic_stats(moment().endOf('month').unix(),moment().startOf('month').unix())
        }
        
      },
      get_outbound_campaigns: function(passed_outbound_campaign_uuid,callback_function) {
        try {
          if(!this.active_user.permissions.includes('campaigns:read') && !this.active_user.permissions.includes('campaigns:create')) {
            return error_popup('do not have permissions to get campaigns?')
          }

          let these_params = {
            org_id: this.active_org.org_id,
            outbound_campaign_type: 'SMS',
            limit_results: this.default_limit || 25
          }
          if(typeof passed_outbound_campaign_uuid !== 'undefined' && passed_outbound_campaign_uuid !== null) {
            these_params.outbound_campaign_uuid = passed_outbound_campaign_uuid
          }

          axios.get('https://'+this.use_this_api_domain+'/outbound_campaign/campaign', { 
                params: these_params,
                headers: {
                    'Authorization': 'Bearer ' + this.active_user_jwt
                }
              }).then((results,error) => {
                if(results.status === 200) {
                  if(results.data && results.data.length && results.data.length > 0) {
                    //console.log('debug 816 campaign data')


                    //220427 only merge new ones that we got
                    if(typeof  this.outbound_campaigns === 'undefined' || !this.outbound_campaigns.length) {
                       this.outbound_campaigns = []
                    }

                    //is empty just append all
                    if(this.outbound_campaigns.length === 0) {
                      this.outbound_campaigns =  results.data
                    } else {
                      //merge
                      this.outbound_campaigns = helpers.merge_array_of_objects(this.outbound_campaigns,results.data,'outbound_campaign_uuid') //(original, newdata, selector = 'key') 
                    }

                    //set the first active
                    let first_active_campaign = null
                    for (let i = 0; i < results.data.length; i++) {

                      try {
                        //220427 i think lists null is creating render problem set it to explicit empty array
                        if(typeof results.data[i].list_uuids === 'undefined' || results.data[i].list_uuids === null) {
                          results.data[i].list_uuids = []
                        }
                        if(typeof results.data[i].scripts === 'undefined' || results.data[i].scripts === null) {
                          results.data[i].scripts = []
                        }
                      } catch(e) {
                        console.log(e)
                      }

                    // console.log('debug ' + i)
                      if(results.data[i].is_active === true) {
                        if(!this.active_outbound_campaign_uuid || this.active_outbound_campaign_uuid === null) {
                          //console.log('debug set this active ampaign on load init ing')
                          if(first_active_campaign === null) {
                            first_active_campaign = this.outbound_campaigns[i]
                          }
                          
                        }
                      }
                    }

                    if(first_active_campaign !== null && first_active_campaign.outbound_campaign_uuid) {
                      this.active_campaign = first_active_campaign
                      this.active_outbound_campaign_uuid = first_active_campaign.outbound_campaign_uuid
                    } else {
                      console.log('debug no active campaign available')
                    }

                    let available_script = null
                    if(first_active_campaign.scripts && first_active_campaign.scripts.length && first_active_campaign.scripts.length > 0) {
                      available_script = first_active_campaign.scripts[0]
                    }
                    let available_list = null
                    if(first_active_campaign.list_uuids && first_active_campaign.list_uuids.length && first_active_campaign.list_uuids.length > 0) {
                      available_list = first_active_campaign.list_uuids[0]
                    }


                    //grab basic stats from spanner
                    if(typeof passed_outbound_campaign_uuid !== 'undefined' && passed_outbound_campaign_uuid !== null) {

                      let process_stats_callback = (results) => {
                        if(results) {
                          if(typeof results !== 'undefined' || results === null) {
                            this.outbound_campaigns_stats =  helpers.merge_array_of_objects(this.outbound_campaigns_stats,results,'outbound_campaign_uuid')
                          } else {
                            console.log('get outbound stats logged result but undefined or null?')
                          }
                        }
                      }

                      this.get_outbound_campaign_stats_callback(passed_outbound_campaign_uuid,['outbound_campaign_uuid'],1,process_stats_callback)
                      
                    } else {

                      let process_stats_callback = (results) => {
                        if(results) {
                          if(typeof results !== 'undefined' || results === null) {
                            this.outbound_campaigns_stats =  helpers.merge_array_of_objects(this.outbound_campaigns_stats,results,'outbound_campaign_uuid')
                          } else {
                            console.log('get outbound stats logged result but undefined or null?')
                          }
                        }
                      }

                      this.get_outbound_campaign_stats_callback(null,['outbound_campaign_uuid'],100,process_stats_callback)

                    }

                    
                    this.cascade_updates_on_new_active_campaign(available_list,available_script,0,1000,first_active_campaign.outbound_campaign_uuid)

                    if(typeof callback_function !== 'undefined') {
                      callback_function()
                    }
                    
                  }
                } else if(results.status === 404 || error.response.status === 404) {
                  if(error){console.log(JSON.stringify(error.data));}
                  return this.error_popup('Error: please contact admin');
                } 
                
              })//then
        } catch(e) {
          console.log(e)
        }
      },
      get_missing_outbound_campaign: function(passed_outbound_campaign_uuid) {
        console.log('debug 1967 missing outbound_campaign')
        this.get_outbound_campaigns(passed_outbound_campaign_uuid)
        
      },
    set_active_list: function(set_this_passed_list_uuid) {
      let this_active_list = {
        org_id: null,
        list_uuid: null,
        list_type:null,
        list_name:null,
        is_active:null,
        date_created: null,
        last_modified:null,
        user_uuid_created: null,
        user_uuid_last_modified: null
      }

      

      //211210 simplify must have set_this_passed_list_uuid
      if(!set_this_passed_list_uuid || set_this_passed_list_uuid === null || set_this_passed_list_uuid === '' || typeof set_this_passed_list_uuid === 'undefined') {
        //missing passed_list_uuid set an empty active_list
        this.active_list = this_active_list
        return
      } else {

        //230308 try to fix change to ordered limit
        //start to get contacts early
        this.grab_new_contacts(15,set_this_passed_list_uuid,'ordered_limit')

        //add a timing check since it possible is GET ing new missing list_uuid
        if(this.currently_setting_this_active_list_uuid && this.currently_setting_this_active_list_uuid !== null && this.currently_setting_this_active_list_uuid === set_this_passed_list_uuid) {
          console.log('debug timing check already inside this function return exit')
          setTimeout(() => {
              this.currently_setting_this_active_list_uuid = null
          }, 5000);
          return
        } else {
          //check if set_this_passed_list_uuid exists in this.contact_lists
          let this_contact_lists_contains_this_list_uuid = false
          let set_this_active_list_object = {}
          this.contact_lists.forEach(this_contact_list => {
            if(this_contact_list.list_uuid === set_this_passed_list_uuid) {
              this_contact_lists_contains_this_list_uuid = true
              set_this_active_list_object = this_contact_list
            }
          });

          if(this_contact_lists_contains_this_list_uuid === true) {
            //set this.active_list
           // console.log('set this_active_list exists in lists setting this list_uuid ' + set_this_active_list_object.list_uuid)
            this.active_list = set_this_active_list_object
          } else {
            //the passed set_this_passed_list_uuid list uuid is not within contact_lists
            //get it
            axios.get('https://'+this.use_this_api_domain+'/contact/list', { 
              params: {
                org_id: this.active_org.org_id,
                script_type:'SMS',
                list_uuid: set_this_passed_list_uuid,
                limit_results: 1
              },
              headers: {
                  'Authorization': 'Bearer ' + this.active_user_jwt
              }
            })
            .then((results,error) => {
              if(results && results.status === 200 ) {
                if(results.data && results.data.length && results.data.length >0) {
            
                  //push into contact_lists
                  //console.log('debug got missing contact_list:')
                  //console.log(results.data[0])

                  //triple check doesn't alreqady exist
                  let list_dupe_check_false_means_exists_dont_push = false
                  this.contact_lists.forEach(existing_list => {
                    if(existing_list.list_uuid === results.data[0].list_uuid) {
                      list_dupe_check_false_means_exists_dont_push = true
                    }
                  });

                  if(list_dupe_check_false_means_exists_dont_push === true) {
                    console.log('debug we got a new list uuid ' + results.data[0].list_uuid + " but that list_uuid already exists in ontact_lists triple check")
                    //do nothing?
                    return
                  } else {
                    //set active_list
                    //console.log('debug new active_list from get set active_list.list_uuid ' + results.data[0].list_uuid)
                    this.active_list = results.data[0]

                    //push into this.contact_lists
                    this.contact_lists.push(results.data[0])

                    this.get_list_stats(set_this_passed_list_uuid)
                  }

                } else {
                  console.log('debug lists is empty but shouldnt be in this section 804?')
                  return this.error_popup('Error: please contact admin about lists');
                }
              } else if(results.status === 404 || error.response.status === 404) {} else {
                if(error){console.log(JSON.stringify(error.data));}


                return this.error_popup('Error: please contact admin about lists');
              }
              
              this.currently_setting_this_active_list_uuid = null
            })
            
      
          }
        }

      }
  
    },
    set_active_script: function(set_this_active_script_uuid) {
      let this_active_script = {
        org_id: null,
        script_uuid:null,
        script_name:null,
        script_type:null,
        script_description: null,
        script_description:null,
        script_text_fallback:null,
        script_text_handlebars:null,
        sms_attachment:null,
        is_active:null,
        date_created: null,
        last_modified: null,
        user_uuid_created:null,
        user_uuid_last_modified:null
      }


      if(!set_this_active_script_uuid || set_this_active_script_uuid === null || set_this_active_script_uuid === '' || typeof set_this_active_script_uuid === 'undefined') {
        this.active_script = this_active_script
        return
      } else {

        //add a timing check
        if(this.currently_setting_this_active_script_uuid && this.currently_setting_this_active_script_uuid !== null && this.currently_setting_this_active_script_uuid === set_this_active_script_uuid) {
          console.log('debug timing check already inside this function return exit')
          setTimeout(() => {
              this.currently_setting_this_active_script_uuid = null
          }, 5000);
          return
        } else {
          //check if set_this_active_script_uuid exists in this.scripts
          let this_scripts_contains_this_script_uuid = false
          let set_this_active_script_object = {}

          this.scripts.forEach(this_contact_script => {
            if(this_contact_script.script_uuid === set_this_active_script_uuid) {
              this_scripts_contains_this_script_uuid = true
              set_this_active_script_object = this_contact_script
            }
          });

          if(this_scripts_contains_this_script_uuid === true) {
            //set this.active_script
            this.active_script = set_this_active_script_object
            //generate active_message
            this.generate_active_message()
          } else {
            //get missing
            axios.get('https://'+this.use_this_api_domain+'/scripts/script', { 
            headers: {
                'Authorization': 'Bearer ' + this.active_user_jwt
            },
            params: {
              org_id: this.active_org.org_id,
              script_type:'SMS',
              script_uuid: set_this_active_script_uuid,
              limit_results: 1
            }
          }).then((results,error) => {
              if(results && results.status === 200 ) {
                if(results.data && results.data.length && results.data.length >0) {
            
                  //push into scripts
                  console.log('debug got missing:')
                  console.log(results.data[0])

                  //triple check doesn't alreqady exist
                  let script_dupe_check_false_means_exists_dont_push = false
                  this.scripts.forEach(existing_script => {
                    if(existing_script.script_uuid === results.data[0].script_uuid) {
                      script_dupe_check_false_means_exists_dont_push = true
                    }
                  });

                  if(script_dupe_check_false_means_exists_dont_push === true) {
                    console.log('debug we got a new script uuid ' + results.data[0].script_uuid + " but that script_uuid already exists in ontact_scripts triple check")
                    //do nothing?
                    return
                  } else {
                    //set active_script
                    this.active_script = results.data[0]

                    //push into this.scripts
                    this.scripts.push(results.data[0])
                  }

                } else {
                  console.log('debug scripts is empty but shouldnt be in this section 804?')
                  return this.error_popup('Error: please contact admin about scripts');
                }
              } else if(results.status === 404 || error.response.status === 404) {} else {
                if(error){console.log(JSON.stringify(error.data));}
                return this.error_popup('Error: please contact admin about scripts');
              } 


              //update quick_replies?
              //220201
              this.set_available_quick_replies()

              //generate active_message
              this.generate_active_message()
              this.currently_setting_this_active_script_uuid = null
            })
            
          }
        }

      }
  
    },
  
    set_available_quick_replies: function() {

      let local_available_quick_replies = []
      let local_available_quick_reply_uuids = []


      if(this.active_script && this.active_script.script_uuid !== null) {

        this.quick_replies.forEach(quick_reply => {
        
            if(quick_reply.is_active === true && ( quick_reply.script_uuid === this.active_script.script_uuid ) ) {
                if(local_available_quick_reply_uuids.includes(quick_reply.quick_reply_uuid) === false) {
                    local_available_quick_reply_uuids.push(quick_reply.quick_reply_uuid)
                    local_available_quick_replies.push(quick_reply)
                }
            
            }

        });

      }

      this.available_quick_replies = local_available_quick_replies
      this.available_quick_reply_uuids = local_available_quick_reply_uuids

      
    },
      search_new_sc_qr_by_script_uuid: function(this_script_uuid) {
        if(this_script_uuid && this_script_uuid !== null && this_script_uuid !== '') {
          axios.get('https://'+this.use_this_api_domain+'/quick_reply', { 
            params: {
              org_id: this.active_org.org_id,
              this_user_uuid: this.active_user.user_uuid,
              script_uuid: this_script_uuid,
              limit_results: this.default_limit || 25
            },
            headers: {
                   'Authorization': 'Bearer ' + this.active_user_jwt
                }

          }).then((results,error) => {
            if(results && results.status === 200 ) {
              if(results.data && results.data.length && results.data.length >0) {
                
                //set_active_script
                

              } else {
                console.log('debug quick_replies is empty')
              }
            }
            if(error) {
              console.log(JSON.stringify(error))
            }
          })
        }
        
      },
      set_active_messenger_service: function(passed_message_service_sid) {
        //console.log('trigger set_active_messenger_service')
        try {
          //is this even necesary how many numbers would one organization have???
         // console.log('set_active_messenger_service '+ passed_message_service_sid)

          let grab_message_services = false
          let set_this_active_messenger_service_data = {}

          //check if this passed exists and is inside message_services
          let skip_lookup_set_manually = false
          if(passed_message_service_sid && passed_message_service_sid !== null) {

            //if the active_messenger_service is already this passed_message_service_sid
            if(this.active_messenger_service && this.active_messenger_service.messaging_service_sid && this.active_messenger_service.messaging_service_sid === passed_message_service_sid) {
              return
            } else {
              //console.log('debug set new active messenger service')
              this.message_services.forEach(message_service => {
                if(message_service.messaging_service_sid === passed_message_service_sid) {
                  //console.log('debug going to set this active messenger service')
                  //console.log(JSON.stringify(message_service))
                  //deep clode
                  set_this_active_messenger_service_data = message_service //JSON.parse(JSON.stringify(message_service))
                  skip_lookup_set_manually = true
                }
              })
            }
            
          } else {
            console.log('no passed_message_service_sid sent into set service function?')
            return
          }

          if(skip_lookup_set_manually === true) {
            //console.log('already has messenger service set it here')
            //console.log(JSON.stringify(set_this_active_messenger_service_data))
            this.active_messenger_service = set_this_active_messenger_service_data
          } else {

              console.log('debug 2345')
              //grab more
              //get
              axios.get('https://'+this.use_this_api_domain+'/twilio/message_service', { 
              params: {
                  org_id: this.active_org.org_id,
                  is_active: true,
                  limit_results: 1,
                  messenger_service_sid: passed_message_service_sid //this.active_campaign.messenger_service_sid
                },
                headers: {
                    'Authorization': 'Bearer ' + this.active_user_jwt
                }
              })
              .then((result,error) => {
                if(error) {
                  console.log('DEBUG 1491 missing messenger services?')
                  return this.error_popup("Contact admin to setup sms service which is required")
                }
                if(!result || !result.data || !result.data.length || result.data.length === 0) {
                  console.log('debug 2376 messenger_service result is empty?')
                  console.log(JSON.stringify(result))
                  return
                } else {
                  
                  //set the active_messenger_service object
                  if(result.data && result.data.length && result.data.length > 0) {
                    console.log('debug got new messenger_service')
                    console.log(JSON.stringify(result))
                    this.active_messenger_service = result.data[0]

                    //add into available phone numbers array
                    result.data.forEach(function(this_message_service,index) {
                      this_message_service.numbers.forEach(individual_number => {

                        //ugh more deep lookups double check not exist
                        let has_existing_match = false
                        this.array_of_number_messenger_services.forEach((number_messenger_service_single,index) => {
                          if(number_messenger_service_single.messaging_service_sid === result.data[index].messaging_service_sid && number_messenger_service_single.phone_number === individual_number) {
                            console.log('debug this message service sid and phone number already in availble array')
                            has_existing_match = true
                          }
                        });

                        if(has_existing_match === false) {
                          this.array_of_number_messenger_services.push({
                            messaging_service_sid: result.data[index].messaging_service_sid,
                            phone_number: individual_number
                          })
                        }
                        
                    
                      })

                    });

                  } else {
                    console.log('debug messenger servce get is empty')
                  }
                  
                } 
                
              })
            
          }

        /*
          if(skip_lookup_set_manually === false) {
            //TODO think about this shouldnt be doing this?
            if(this.message_services && this.message_services.length && this.message_services.length > 0) {
              if(this.active_campaign && this.active_campaign.outbound_campaign_uuid !== null) {
                for (let i = 0; i < this.message_services.length; i++) {
                  if(this.message_services[i].messaging_service_sid && this.message_services[i].messaging_service_sid !== null) {
                    if(this.active_campaign.messaging_service_sid === this.message_services[i].messaging_service_sid) {
                      this.active_messenger_service = this.message_services[i]
                      grab_message_services = true
                    }
                  }
                }
              } else {
                //just set the first one
                this.active_messenger_service = this.message_services[0]
              }
            } else {
              grab_message_services = true
            }
          }
          */

          
        } catch(e) {
          console.log(e)
        }
      },
      calculate_this_front_conversation_sent_to_number: function() {
        let return_this_number = null
        //console.log('debug calculate_this_front_conversation_sent_to_number function call')
        //check that it is different
        //console.log(JSON.stringify(this.this_vue_data_front_context))
        if(typeof this.this_vue_data_front_context !== 'undefined' && typeof this.this_vue_data_front_context.type !== 'undefined' && this.this_vue_data_front_context.type === 'singleConversation') {
          //console.log('debug 450')
            if(this.this_vue_data_front_context.conversation.type === 'sms') {
                return_this_number = this.this_vue_data_front_context.conversation.recipient.handle
            } else if(Array.isArray(this.this_vue_data_front_context.conversation.recipient.contact.handles) && this.this_vue_data_front_context.conversation.recipient.contact.handles.length > 0) {
                this.this_vue_data_front_context.conversation.recipient.contact.handles.forEach(handle => {

                    if(handle.type === 'phone') {
                       // console.log('found number ' + handle.handle)
                       if(handle.handle && handle.handle.lenght > 9) {
                         return_this_number =  handle.handle
                       } else {
                         console.log('debug front context number is not long enough?')
                         console.log(JSON.stringify(this.this_vue_data_front_context))
                         return_this_number = null
                       }
                        
                    }

                });
            } else {
                //TODO in future loop over customAttributes -> cell_phone ?
               
            }
           
        } else {
          //is not a new converstion keep the state
          return_this_number = this.last_computed_sent_to_number
        }
        this.last_computed_sent_to_number = return_this_number
        this.this_front_conversation_sent_to_number =  return_this_number
        return return_this_number
      },
      
      set_default_contact_data() {
        console.log('debug set default this.contact_data')
        this.contact_data = {
          actblue_sum:{},
          actblue:[],
          incoming_messages:[],
          outbound_messages:[],
          merged_messages: [],
          contact_lists_data:{},
          survey_question_answers: []
        }
      },
      assign_these_survey_question_answers_to_contact(sc_post_response) {
        console.log('debug assign_these_survey_question_answers_to_contact ')
        console.log(sc_post_response)
        if(sc_post_response && sc_post_response !== null) {
          //220708
          this.contact_data.survey_question_answers = helpers.merge_array_of_objects(this.contact_data.survey_question_answers,sc_post_response,'survey_question_uuid')
        }
      },
      get_this_contact_data_survey_question_responses(this_sent_to,this_contact_uuid) {
        if(!this_sent_to && !this_contact_uuid) {
          console.log('debug 3789 need to have a sent_to or contact_uuid to get this contact survey question answers')
          return
        }
        let the_params = {
          org_id: this.active_org.org_id
        }
        if(this_sent_to && this_sent_to !== null) {
          the_params.sent_to = this_sent_to
        }
        if(this_contact_uuid && this_contact_uuid !== null) {
          the_params.contact_uuid = this_contact_uuid
        }
        this.get_survey_question_response(the_params,this.assign_these_survey_question_answers_to_contact)
      },
      get_contact_stats(sent_to_array, fields, limits,org_id,user_uuid) {

          try {
            console.log('debug 4074')
            this.set_default_contact_data()

            //console.log(sent_to_array)
            //console.log(fields)
            //console.log(limits)
            //console.log(org_id)
            //console.log(user_uuid)

            if(!sent_to_array || !fields || !limits || !org_id || !user_uuid) {
                console.log('debug missing params for get_contact_stata')
                return {data:null,error:'missing params'}
            }
            let these_contacts_objects = []
            sent_to_array.forEach(sent_to => {

              if(!sent_to || sent_to === null || !sent_to.length || sent_to.length < 10) {
                //sent_to not long enough front problem
              } else {
                these_contacts_objects.push({
                    sent_to: sent_to,
                    fields: fields,
                    limits: limits
                })
              }
                
            });

            if(!these_contacts_objects || !these_contacts_objects.length || these_contacts_objects.length === 0) {
              //another check on front errors let's reset so the old contact pane goes away
              console.log('debug 4104')
              return this.clear_is_pulling_this_contact()
            }

            //console.log('contacts debug ')
          // console.log(these_contacts_objects)

            let stringified_these_contacts_objects = safe_buffer.from(JSON.stringify(these_contacts_objects)).toString('base64')

            axios.get('https://'+this.use_this_api_domain+'/contact/contact', { 
              params: {
                org_id:org_id,
                user_uuid: user_uuid,
                contacts: stringified_these_contacts_objects
              },headers: {
                  'Authorization': 'Bearer ' + this.active_user_jwt
              }
            })
            .then((response,error) => {
              
            
                if(error) { 
                  console.log(JSON.stringify(error))
                  //reset
                  return this.clear_is_pulling_this_contact()
                }
                else if(response) {
                    console.log('debug got this contact data')
                    if(response.status && response.status === 200) {

                      if(response.data) {
  
                          if(response.data !== null) {

                            console.log(response.data)

                            response.data.forEach(response_object => {
                                  
                              console.log('debug contact_data single object')
                              console.log(JSON.stringify(response_object))

                              //make sure has a contact match sometimes for cutoff numbers it doesnt
                              if(response_object.result && response_object.result.length && response_object.result.length > 0) {
                                if(response_object.name) {
                                  if(response_object.name === 'incoming_messages') {
                                    //TODO should be automatically sorted but maybe add a timestamp check here in the future
                                    this.this_conversation_contact_last_incoming_message = response_object.result[0]
                                    
                                    this.contact_data.incoming_messages = response_object.result

                                    console.log('debug has incoming_messages set')

                                    response_object.result.forEach(single_message => {
                                      
                                      single_message.direction = 'incoming'
                                      this.contact_data.merged_messages.push(single_message)
                                    });
                                    //this.contact_data.merged_messages = this.contact_data.merged_messages.contact(response_object.result)
                                  } else if(response_object.name === 'outbound_messages') {
                                    this.this_conversation_contact_last_sent_campaign_message = response_object.result[0]
                                    //keep array
                                    this.contact_data.outbound_messages = response_object.result
                                    //this.contact_data.merged_messages = this.contact_data.merged_messages.contact(response_object.result)
                                    response_object.result.forEach(single_message => {
                            
                                      single_message.direction = 'outbound'
                                      this.contact_data.merged_messages.push(single_message)
                                    });
                                  } else if(response_object.name === 'actblue') {
                                    //keep array
                                    this.contact_data.actblue = response_object.result
                                  } else if(response_object.name === 'actblue_sum') {
                                    this.contact_data.actblue_sum = response_object.result[0]
                                  } else if(response_object.name === 'contact_lists_data') {
                                    console.log('this contact_lists_data')
                                    console.log(JSON.stringify(response_object.result[0]))
                                    this.contact_data.contact_lists_data = response_object.result[0]
                                    //fire sc get
                                    this.get_this_contact_data_survey_question_responses(response_object.result[0].sent_to || null,response_object.result[0].contact_uuid || null)
                                    
                                  } else {
                                    console.log('error there is a bad response object name???')
                                  }
                                }

                                  //re arrange merged messages by time
                                this.contact_data.merged_messages.sort(function (a, b) {
                                  var dateA = new Date(a.date_created), dateB = new Date(b.date_created)
                                  return dateA - dateB
                                });


                                //TODO if inside front auto add missing contact fields (email etc) into the profile. and the other way around?

                                console.log('debug set has_contact_data true')
                                console.log(JSON.stringify(this.contact_data))

                                this.has_contact_data = true

                                //manual int refresh?
                                this.update_backdoor = this.update_backdoor + 1

                                if(this.is_debug && this.is_debug === true) {
                                  //console.log('debug this.contact_data')
                                  //console.log(JSON.stringify(this.contact_data))
                                }
                          
                                //do not change if in send_message tab
                                if(this.active_tab_name && this.active_tab_name === 'send_messages') {
                                  return 
                                } else {
                                  return this.change_tab('this_contact')
                                }

                              } else {
                                console.log('debug no result clear')
                                //it looked up succesfully but has no data
                                return this.clear_is_pulling_this_contact()

                              }
                            });
                          } else {
                            console.log('debug timing 3962')
                            this.clear_is_pulling_this_contact()
                          }
                      } else {
                        console.log('debug timing 33966')
                        this.clear_is_pulling_this_contact()
                      }
                    } else {
                      console.log('debug timing 3970')
                      this.clear_is_pulling_this_contact()
                    }
                } else {
                  console.log('debug timing 3974')
                  this.clear_is_pulling_this_contact()
                }
            })

        } catch(e) {
            console.log(e)
            return this.clear_is_pulling_this_contact()
        }
      },
      clear_is_pulling_this_contact: function() {
        console.log('debug clearing pull this contact')
        this.set_default_contact_data()
        this.has_contact_data = false
        this.is_processing_get_contact = false
        this.change_tab('home')
      },
      grab_twilio_log: function(get_vars,callback_function) {
        console.log('debug grab_twilio_log')
        try {

          if(typeof get_vars === 'undefined' || get_vars === null) {
            console.log('2719 missing passed vars?')
            this.clear_is_pulling_this_contact()
            return this.error_popup('error grabbing twilio log')
          }

          console.log('typeof callback_function ' + typeof callback_function)

          console.log('twilio log get_vars')
          console.log(JSON.stringify(get_vars))

          axios.get('https://'+this.use_this_api_domain+'/twilio/message', { 
              params: get_vars,headers: {
                  'Authorization': 'Bearer ' + this.active_user_jwt
              }
            })
            .then((response) => {
              
              if(response) {

                console.log('grab twilio log body')
                if(response.status && response.status === 200) {
                  if(response.data) {
                    if(response.data !== null) {
                      if(response.data.length && response.data.length > 0) {
                        console.log(JSON.stringify(response.data))

                        if(response.data.length > 1) {
                          console.log('found too many options....')
                          this.clear_is_pulling_this_contact()
                          
                        } else {
                          console.log('going to grab this_contact data byt this sent_to ')
                          console.log(response.data)
                          this.this_front_conversation_sent_to_number = response.data[0].from

                          if(callback_function) {
                            console.log('call callback')
                            return callback_function(response.data[0].from)
                          } else {
                            console.log('error 2713 no callback function?')
                            this.clear_is_pulling_this_contact()
                          }

                        
                        }
                      } else {
                        console.log('no results?')
                        this.clear_is_pulling_this_contact()
                      }
                    }
                  }
                } else {
                  console.log('debug response status not 200 but shouldnt bere here... ')
                  console.log(JSON.stringify(response))
                  this.clear_is_pulling_this_contact()
                }

              } else {
                console.log('debug 2853 ')
                this.clear_is_pulling_this_contact()
              }
            })
            .catch((error) => {
              console.log('process get contact error')
              if(error) {
                console.log(error)
              }
              this.clear_is_pulling_this_contact()
            })

        } catch(e) {
          console.log('error 2817')
          console.log(e)
          return this.clear_is_pulling_this_contact()
          
        }
      }
      

    }, //end methods
    mixins: [
     //data_sync_mixin
    ],
    
  };




  //example of how to call i think
  //data_sync_mixin.methods.mixin_get(null)
  //data_sync.mixin_get()



</script>
<style>

:root, body {

  background: #fff;
}
.flat_pills .nav-link {
    padding: 0.75rem 1rem;
    color: var(--default);
    font-weight: 500;
    font-size: 0.875rem;
    -webkit-box-shadow:none;
    box-shadow:none;
    background-color: #fff;
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s ease;
}
.nav_top_small {
  width: 100% !important;
  max-width: 100% !important;
}
  body,document {
    box-sizing: border-box;
  }
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .navbar {
    border-bottom: 1px solid #dee2e6;
  }
  .nav-item, .navbar-light .navbar-nav .nav-link, .dropdown-item {
    color: var(--gray-600);
    font-size: 11px;
    cursor:pointer;
  }
  .nav-item:hover, .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus, .nav-item:active, .nav-link:active {
    color:var(--blue)
  }

  .navbar-horizontal .navbar-nav .nav-link-icon, .navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text, .navbar-horizontal .navbar-nav .nav-link {
    text-align:center;
    padding-top: 5px;
    padding-bottom: 5px;
    line-height: 25px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .b-nav-dropdown {
    padding-left: 0px;
    padding-right: 0px;
  }
  .nav-spacer-left {
    box-sizing:border-box;
    margin-left: 2rem;
  }

  .message_bubble_blue a, .bubble_green a {
    text-align:center;
  }
  .message_bubble_blue, .bubble_green {
    cursor: pointer;
    text-align:center;
    vertical-align: baseline;
    font-size:12px !important;
    display: inline-block !important;
    border-radius: 12px !important;
    color: rgb(255, 255, 255) !important;
    padding: 8px 16px !important;
    width: auto !important;
  }
  .bubble_green {
    background-color: var(--bg-green) !important;
  }
  .bubble_green:hover, .bubble_green:active {
    background-color: var(--bg-green-darker) !important;
  }
  .message_bubble_blue {
    background-color: var(--blue) !important;
  }
  .message_bubble_blue:hover,.message_bubble_blue:active {
    background-color:var(--blue-darker) !important;
  }
  .small_btn_text {
    font-size: 11px;
    text-align:center;
    display:block;
    margin-top: -3px;
  }
  .small_btn_text_bottom {
    margin-top: -10px;
  }

  .small_btn_text_inline {
    font-size: 11px;
    text-align:center;
    display:inline-block;
    margin-left: 8px;
  }
  
  .nav-bar {
    text-align:center;
  }
  .active_nav_button_color .material-icons, .active_nav_button_color .small_btn_text {
    color:var(--blue) !important;
  }

  .material-icons.md-24 {
    color:var(--white);
  }

.navbar-expand .navbar-nav {
  width: 100%;
  justify-content: center;
}
.card-stats {
  background: var(--secondary)
}

.container-fluid {
  padding:0px;
}
.card {
  box-shadow: none;
}

.color-white {
  color:#fff;
}
.icon_blue {
  color:var(--blue)
}

.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  border: none;
  box-sizing: border-box;
  vertical-align:bottom;
  border-radius: 0px;
  border-bottom: 2px solid var(--gray-dark);

}
.nav-item, .navbar-light .navbar-nav .nav-link, .dropdown-item {
  font-size: 14px;
  vertical-align:bottom;
}
.nav-item {
  margin-right: 20px;
}
.nav-tabs .nav-link {
  border-radius:0px;
  border-left: 0px;
  border-right:0px;
  border-top: 0px;
  padding-left:0px;
  padding-right: 0px;
  border-bottom: 2px solid #fff;
}
.nav-tabs {
  border-bottom: 1px solid var(--gray-light);
  box-sizing: border-box;
  vertical-align:bottom;
  margin-bottom: 10px;
}

.nav-tabs .nav-item {
  margin-bottom: 0px;
}
.tab-pane {
  padding: 10px;
}

.click_cursor {
  cursor: pointer;
}

.el-select .el-select__tags .el-tag {
  background: var(--gray-700)
}

  @media (min-width: 992px) {
    .navbar-horizontal .navbar-nav .nav-link {
      padding-top: 5px;
      text-align:center;
      padding-bottom: 5px;
      line-height: 25px;
    }
    .message_bubble_blue, .bubble_green {
      border-radius: 12px !important;
      padding: 10px 24px !important;
    }
    
  }


@media (max-width: 500px) {
  .navbar-horizontal .navbar-nav .nav-link-icon, .navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text, .navbar-horizontal .navbar-nav .nav-link {
    padding-left: 5px;
    padding-right: 5px;
  }
  .card-header {
    padding-left: 15px;
    padding-right: 0px;
  }
  .card-body {
    padding-left: 5px;
    padding-right: 5px;
  }
  .b-nav-dropdown { 
    padding-left: 7px;
    padding-right: 7px;
  }
}
  
</style>
